const en = {
  // --- Application wide ---

  id: "Id",
  closeButton: "Close",
  saveButton: "Save",
  cancelButton: "Cancel",
  restartButton: "Restart",
  continueButton: "Continue",
  nextButton: "Next",
  reuploadButton: "Re-upload",
  deleteButton: "Delete",
  chooseFileButton: "Choose",
  importButton: "Import",
  cancelSearchButton: "Cancel Search",
  processButton: "Process",
  clearButton: "Clear",
  exportButton: "Export",
  courseLabel: "Course",
  fileNameLabel: "File Name",
  uploadFileLabel: "Upload File",
  noResults: "No Results",
  propertiesLabel: "Properties",
  applicationLabel: "Application",
  configurationLabel: "Configuration",
  operationsLabel: "Operations",
  importsLabel: "Imports",
  testDataGenerationLabel: "Test Data Generation",
  e2eRegressionTestsLabel: "E2E Regression Test Results",
  developerDashboardLabel: "Developer Dashboard",
  dashboardRefreshTriggered:
    "Dashboard refresh triggered. Data will update shortly.",
  dashboardRefreshFailed: "Dashboard refresh failed. Please try again.",
  dashboardRefreshConfirmTitle: "Refresh dashboard?",
  dashboardRefreshConfirmContent:
    "This recomputes all dashboard data from Jira and Bitbucket and can take a few seconds. Continue?",
  processesLabel: "Processes",
  filtersLabel: "Filters",
  summaryLabel: "Summary",
  addEntity: "Add {entity}",
  reminderSelectOrganization:
    "Please select an Organization different from 'Knowfully Learning Group'.",
  reminderSelectMigrationType:
    "Please select a Migration Type in order to import the file.",
  csvFileInfo: "Please make sure your CSV file conforms to our CSV sample file",
  csvEmptyMessage: "The file that you provided has no rows to be processed.",
  csvFileDownload: "Download sample CSV",
  loading: "Loading...",
  searchPlaceholder: "Search...",
  userSearchPlaceholder: "Search by email...",
  userLabel: "Filter by User",
  fetchError: "Error fetching data...",
  serverError: "An error on the server has ocurred.",
  backToDetailsButtonLabel: "Back to Details",
  backToListButtonLabel: "Back to List",
  backToUser: "Back to User",
  backToUserCourse: "Back to User Course",
  backToExamResults: "Back to Exam Results",
  backToSkuButtonLabel: "Back to SKU",
  unspecified: "-Not specified-",
  date: "Date",
  dateFrom: "Date From",
  dateTo: "Date To",
  unauthorizedLabel: "Unauthorized",
  unauthorizedMessage: "You're not allowed to access this resource",
  knowfullyAdmin: "Knowfully Admin",
  youDontHaveAccount: "You don't yet have a KnowFully Admin account.",
  accountNotFoundHelp:
    "Please contact the Technology team to have your account onboarded.",
  internalServerErrorMessage:
    "There was an error processing the request. Please contact support!",
  errorLabel: "Error",
  notFoundLabel: "404 : Not Found",
  notFoundMessage:
    "The specified route was not found or you're not authorized.",
  copiedToClipboardMessage: "Copied to clipboard",
  copyToClipboardFailed: "Copy to clipboard failed",
  createNew: "Create New",
  update: "Update",
  addExisting: "Add Existing",
  newAttribute: "New Attribute",
  selectAttributeTypeMessage:
    "Select an attribute type to display the options.",
  anyLabel: "Any",
  messageLabel: "Message",
  rowNumberLabel: "CSV Row N°",
  allOthersLabel: "All Others",
  allApprovedProfessionsLabel: "All Approved Professions",
  allApprovedStatesLabel: "All Approved States",
  uploadDate: "Upload Date",
  creditSubmissionReports: "Credit Submission Reports",
  creditSubmissionReportsListTitle: "Credit Submission Report",
  exportCreditSubmissionReportTitle: "Export Credit Submission Report",
  cancelJob: "Cancel Job",
  activeLabel: "Active",
  inactiveLabel: "Inactive",
  openLinkInNewTab: "Open Link In New Tab",
  notes: "Notes",
  okButton: "Ok",
  executeButton: "Execute",
  profilePictureLabel: "Profile picture",
  contentBlockLabel: "Content block",
  bioLabel: "Bio",
  nameLabel: "Name",
  hostNameLabel: "Host Name",
  orderTypeLabel: "Order Type",
  secretLabel: "Secret",
  companyLabel: "Company",
  companyCodeLabel: "Company code",
  sendExternalMessagesLabel: "Send External Messages",
  partnerTypeInternal: "Internal",
  partnerTypeExternal: "External",
  titleLabel: "Title",
  backLabel: "Back",
  typeLabel: "Type",
  valueLabel: "Value",
  descriptionLabel: "Description",
  color: "Color",
  image: "Image",
  parentOrganizationLabel: "Parent Organization",
  corporateEntityLabel: "Corporate Entity",
  productVersionLabel: "Product Version",
  productYearLabel: "Product Year",
  productDetails: "Product Details",
  maxPriceLabel: "Max Price",
  minPriceLabel: "Min Price",
  orientation: "Orientation",
  landscape: "Landscape",
  portrait: "Portrait",
  actions: "Actions",
  deleteLabel: "Delete",
  cloneLabel: "Clone",
  copyLabel: "Copy",
  editLabel: "Edit",
  viewLabel: "View",
  codeConstantLabel: "Code Constant",
  placeholderLabel: "Placeholder",
  parentLabel: "Parent",
  groupLabel: "Group",
  newLabel: "New {name}",
  contentBlockSaveFailed: "Content block save failed",
  imageToSaveIsLarge:
    "The image that you're trying to save is too big, max size is {size}",
  manageLabel: "Manage",
  seeMoreLabel: "See more",
  moreOptionsLabel: "More Options",
  deleteRegistration: "Delete Registration",
  deleteRegistrationTitle: "Delete Registration for {name}",
  deleteRegistrationSuccess: "Registration has been successfully deleted",
  confirmDelete: "Confirm delete",
  areYouSure: "Are you sure?",
  certifyCourseLabel: "Certify Course",
  certifyCourseTitle: "Certify Course for {name}",
  certifyUserSkuLabel: "Certify User SKU",
  certifyThisCourseLabel: "Certify this Course",
  certifyCourseConfirmationMessage:
    "Are you sure? {linebreak} You are about to mark this course as completed, regardless of how far along the Learner has progressed. This will cause Certificates to be generated and Credit Submission where applicable. {linebreak} Please confirm the details above is correct before proceeding.",

  dateOfCompletionLabel: "Date Of Completion",
  certifyUserSkuMessageSent: "Your request to certify (course) has been sent",
  enrollmentChangesSaved: "The Enrollment changes were saved!",
  certifyLabel: "Certify",
  bulkAddSkuQualificationConfirmationText:
    "By clicking Confirm, you will bulk create SkuQualifications based on the Qualification Approvals for this Qualification. Minimum Credits and Partial Credit Increments will be automatically calculated if they are applicable.",
  // --- Form validation errors ---

  requiredLabel: "Required",
  inputValueTooLongLabel: "Input value is too long",
  requiredConditionally: "Required conditionally",
  requiredIfLive: "Required when Sku Availability is 'Live'",
  invalidEmailError: "Please provide a valid email address.",
  tooShortError:
    "Should be at least {minLen, plural, one {# character} other {# characters}} long!",
  invalidPasswordError:
    "The password must have at least 8 characters and contain at least a capital letter, a lower case letter, a digit and a special character (!@#$%^&*).",
  invalidUrlError: "Please provide a valid URL.",
  invalidDate: "Please provide a valid Date",
  invalidGuid: "Please provide a valid GUID",
  refresh: "Refresh",
  urlWithHttpError:
    'The host name and external host name must not have "http" or "https".',
  iframeRequired: "Iframe is required",
  invalidIframe: "Content must be a valid iframe",

  // --- SCORM ---

  scorm: "SCORM",
  addExportCourses: "Add/Export Courses",
  addExportCoursesPageTitle: "Add/Export SCORM Courses",
  addExportCoursesStep1Title: "Imports Step 1: Upload File",
  addExportCoursesStep2Title: "Imports Step 2: Summary",
  addExportCoursesStepReview:
    "Please verify the information below before proceeding",
  addExportCoursesOrganizations: "Organizations to export to",
  addExportCoursesOrganizationsInfo:
    "Only organizations with a valid Rustici Organization External Reference and an existing Content Controller account are listed.",
  addExportCoursesOrganizationsUnder:
    "Listing organizations under: {organization}",
  addExportCoursesNoOrganizations:
    "No organization under this scope has a Content Controller account, so there is nothing to export to.",
  addExportCoursesFile: "Course file",
  addExportCoursesFileUpload: "Upload the metadata file",
  addExportCoursesFileHelp: "Drag and drop a file here or click",
  addExportCoursesFileInvalidHeader:
    "The first column of the metadata file must be headed 'Content Provider Unique ID'.",
  addExportCoursesPreparing: "Preparing the export",
  addExportCoursesPreparingDetail:
    "Storing the metadata workbook and queueing the run. A large workbook can take a moment - leaving this page will not stop it.",
  addExportCoursesFileMissingScormColumn:
    "The metadata file needs a 'SCORM File Name' column on its first sheet, which the export writes each course's zip file name into.",
  addExportCoursesFileNoSkus:
    "No skus were found in the first column of the metadata file.",
  addExportCoursesFileTooManySkus:
    "That file holds more than 10000 skus. Split it into smaller files.",
  addExportCoursesFileUnreadable:
    "That file could not be read as an Excel workbook.",
  addExportCoursesFileReading: "Reading the file...",
  addExportCoursesSkusLoaded: "sku(s) loaded",
  addExportCoursesContentType: "Content type",
  addExportCoursesContentTypeScorm12: "SCORM 1.2",
  addExportCoursesContentTypeScorm2004Third: "SCORM 2004 3rd Edition",
  addExportCoursesContentTypeScorm2004Fourth: "SCORM 2004 4th Edition",
  addExportCoursesOperation: "Operation",
  addExportCoursesAssignAndExport: "Assign Courses & Export",
  addExportCoursesExportOnly: "Export Existing Courses Only",
  addExportCoursesTag: "Tag",
  addExportCoursesTagAutoGeneratedValue: "Auto-generated",
  addExportCoursesTagAutoGenerated:
    "Tag will be auto-generated if left blank",
  addExportCoursesTagDuplicate:
    "This tag already exists, please enter a different text.",
  addExportCoursesConcurrency: "Concurrency",
  addExportCoursesNext: "Next",
  addExportCoursesStart: "Start export",
  addExportCoursesQueued:
    "The export has started. Follow its progress on Operations → Processes.",
  scormCourseExportDescription:
    "Import SCORM courses into Rustici Content Controller, assign them to the selected organizations and export a zip per organization.",

  // --- Generate SCORM Metadata File ---

  generateScormMetadata: "Generate Metadata File",
  generateScormMetadataPageTitle: "Generate SCORM Metadata File",
  generateScormMetadataDescription:
    "This feature exports a metadata file in XLSX format to include with SCORM updates sent to vendors. Select the file content:",
  generateScormMetadataAllProducts: "All Products",
  generateScormMetadataWebinars: "Webinars",
  generateScormMetadataSelfStudyDownload: "Self-Study Download",
  generateScormMetadataSelfStudyWebcasts: "Self-Study Webcasts",
  generateScormMetadataGenerate: "Generate",
  generateScormMetadataInProgress:
    "Generating the metadata file. This may take a while; metadata.xlsx will download automatically when it is ready.",
  generateScormMetadataEmpty:
    "No products match the selected options, so no file was generated.",
  generateScormMetadataDownloaded:
    "metadata.xlsx was generated with {count} record(s).",

  // --- Exported SCORM Files ---

  exportedScormFiles: "Exported SCORM Files",
  exportedScormFilesExportedColumn: "Exported",
  exportedScormFilesStatusUploaded: "Uploaded",
  exportedScormFilesStatusFailed: "Failed",
  exportedScormFilesNumSelected: "{numSelected} file(s) selected",
  exportedScormFilesDownloadSelected: "Download Selected",
  exportedScormFilesUploadSelected: "Upload Selected",
  exportedScormFilesDateInvalid: "Enter a date in MM/DD/YYYY format.",
  exportedScormFilesDateAfterEnd:
    "Start Date cannot be later than End Date.",
  exportedScormFilesDateBeforeStart:
    "End Date cannot be earlier than Start Date.",
  exportedScormFilesUploadOneConfirmation:
    "Send ''{fileName}'' to the FTP or Dropbox destination configured for its organization? A delivered file cannot be sent again from this screen.",
  exportedScormFilesUnreportedAttemptTooltip:
    "The previous attempt has not reported yet. Uploading again may deliver this file twice.",
  exportedScormFilesUploadConfirmation:
    "Send the selected file(s) to the FTP or Dropbox destination configured for each file's organization?",
  exportedScormFilesDownloadTooltip: "Download this file",
  exportedScormFilesUploadTooltip:
    "Upload this file to its organization's destination",
  exportedScormFilesAlreadyUploadedTooltip:
    "Already uploaded, so it is not sent again from this screen",
  exportedScormFilesAlreadyQueuedTooltip:
    "Queued from this screen and still being uploaded",
  exportedScormFilesRetryUploadTooltip:
    "The last upload failed - send this file to its organization's destination again",
  exportedScormFilesUploadQueued:
    "Queued {queuedCount} file(s) for upload. Each row's status reports the result.",
  exportedScormFilesUploadPartiallySkipped:
    "Queued {queuedCount} file(s); {skippedCount} were skipped because they are already uploaded or still being uploaded.",
  exportedScormFilesUploadPartiallyQueued:
    "Queued {queuedCount} file(s), but {notQueuedCount} could not be queued. Try again - the file(s) already queued are skipped, so nothing is sent twice.",
  exportedScormFilesUploadPartiallyQueuedNamed:
    "Queued {queuedCount} file(s), but {notQueuedCount} could not be queued: {refusedNames}. Try those again - the file(s) already queued are skipped, so nothing is sent twice.",
  exportedScormFilesUploadAllSkipped:
    "Nothing was queued: all {skippedCount} selected file(s) are already uploaded or still being uploaded.",
  exportedScormFilesUploadError: "The upload could not be queued.",
  exportedScormFilesDownloadError: "The download could not be produced.",

  // --- Rustici Courses ---

  deactivateRusticiCourses: "Deactivate Rustici Courses",
  deactivateRusticiCoursesPageTitle:
    "Deactivate Rustici Content Controller Courses",
  fetchCoursesFromRusticiCC: "Fetch Courses From Rustici CC",
  coursesFoundInRusticiCC: "Courses Found in Rustici CC",
  addCoursesToDeactivate: "Add the courses to Deactivate",
  enabledLabel: "Enabled",
  locationLabel: "Location",
  updatedDateLabel: "Updated date",
  deactivateLabel: "Deactivate",
  rusticiOrganizationHeader: "Organization: {organizationName}",
  rusticiModeSelfStudy: "All Self-Study",
  rusticiModeWebinars: "All Webinars",
  rusticiModeCustom: "Custom",
  rusticiOrganizationAboveScormRoot:
    "You must select a lower level organization to proceed",
  rusticiOrganizationNotLinked:
    "This organization is not linked to a Content Controller account",
  rusticiContentControllerAccountNotFound:
    "This organization is linked to a Content Controller account that does not exist on the connected Content Controller instance. {detail}",
  rusticiOrganizationHasAmbiguousAccounts:
    "This organization is linked to more than one Content Controller account, so the courses to deactivate cannot be determined. Correct the external references before continuing. {detail}",
  confirmDeactivation:
    'Are you sure you want to deactivate the selected courses for "{organizationName}"? This action will affect all courses matching the selected criteria.',
  confirmDeactivationAllOrganizations:
    "Are you sure you want to deactivate the selected courses for {organizationName}? This action will affect all courses matching the selected criteria for ALL the organizations.",
  rusticiDeactivationTarget:
    "This will affect {courseCount, plural, one {# course} other {# courses}} on {host}.",
  rusticiDeactivationInProgress:
    "This is being processed. Please do not leave this dialog until it finishes.",
  rusticiDeactivationSucceeded:
    "{succeeded, plural, one {# course has} other {# courses have}} been successfully deactivated.",
  rusticiDeactivationFailed:
    "{failed, plural, one {# course} other {# courses}} failed to be deactivated.",
  rusticiDeactivationSkipped:
    "{skipped, plural, one {# course was} other {# courses were}} skipped for no longer matching the selection.",

  // --- Agreements ---
  agreements: "Agreements",
  agreement: "Agreement",
  dueDate: "Due Date",
  userAgreements: "User Agreements",
  assignFacultyAgreement: "Assign Faculty Agreement",
  additionalFields: "Additional Fields",
  dueDateLabel: "Due Date",
  assignAgreement: "Assign Agreement",
  cancelAgreementConfirmationMessage:
    "Are you sure you want to cancel this user agreement?",
  cancelAgreement: "Cancel Agreement",
  cancelSkuUserAgreementSuccessMessage: "Agreement successfully cancelled.",
  facultyAlreadyAssignedToAgreement:
    "The selected faculty user already has a pending or accepted agreement for this sku",
  userAgreementTitle: "{name}'s User Agreement",
  organizationMismatchTitle: "Organization Mismatch",
  organizationMismatchMessage:
    "The selected faculty and user agreement belong to different organizations. Do you want to continue?",

  // --- Attributes ---
  attributes: "Attributes",
  noAttributeTypesForOrganization:
    "There's no attribute types configured for the selected organization. Please select a different organization",
  attributeDeleted: "Attribute deleted.",
  attributeDeleteTitle: "Delete Attribute",
  attributeDeleteQuestion: "Are you sure you want to delete this attribute?",
  createAttributeLabel: "Create {attributeType}",
  editAttributeLabel: "Edit {attributeType}",
  attributeAlreadySelectedForSku:
    "This attribute type only allows one single option selection. You need to remove the existing to add a new one",

  skuAttributeRepeated: "Sku Attribute already added.",

  // --- Content Blocks ---
  contentBlocks: "Content Blocks",
  createContentBlock: "Create Content Block",
  editContentBlock: "Edit Content Block",
  deleteContentBlock: "Delete Content Block",
  contentBlockDeleted: "Content block has been deleted.",
  confirmDeleteContentBlock:
    "Are you sure you want to delete this content block?",
  errorDeletingContentBlock: "Error deleting content block. Please try again.",

  // --- Menu ---

  menubarHome: "Home",
  importsSummary: "Imports Summary",
  importsProcessWarningMessage:
    "Uploading file to the system. Please, do not close the page and wait until it's completed.",
  menubarUsers: "Users",
  menubarGradeUserExams: "Grade User Exams",
  menubarLogout: "Logout",
  menubarCourses: "Courses",
  menubarProducts: "Products",
  newProduct: "New Product",
  menubarSkus: "SKUs",
  menubarSeries: "Series",
  menubarQuestions: "Questions",
  menubarResourceLibraries: "Resource Libraries",
  menubarCertificates: "Certificates",
  menubarThemes: "Themes",
  menubarTemplates: "Templates",
  menubarLocations: "Locations",
  menubarDynamicMenu: "Dynamic Menu",
  menubarMenu: "Menu",
  menubarMenuItems: "Menu Items",
  menubarMenuStructures: "Menu Structures",
  menubarImports: "Imports",
  menubarRequests: "Requests",
  menubarEvents: "Events",
  menubarAccreditation: "Accreditation",

  // --- Authentication ---

  authUsernameFieldLabel: "User name",
  authPasswordFieldLabel: "Password",
  authLoginButton: "Logon",

  // --- Locations ---
  locationNameLabel: "Location Name",
  address1Label: "Address 1",
  cityLabel: "City",
  locationStateLabel: "State",
  locationTypeLabel: "Location Type",
  selectLocationTypeFetchFailed: "Unable to fetch location types...",
  locations: "Locations",
  locationLoadError: "Error retrieving location",
  locationFormTypeLabel: "Location Type",
  sponsorTypeLabel: "Sponsor Type",
  sponsorTypeSponsor: "Sponsor",
  sponsorTypeJointProvider: "Joint Provider",
  locationFormCompanyLabel: "Company",
  locationFormAddress1Label: "Address 1",
  locationFormAddress2Label: "Address 2",
  locationFormAddress3Label: "Address 3",
  locationFormStateLabel: "State",
  locationFormZipCodeLabel: "Zip Code",
  locationFormPhoneLabel: "Phone",
  locationFormFaxLabel: "Fax",
  locationFormDirectionsLabel: "Directions",
  locationDeleteTitle: "Delete Location",
  locationDeleteInfo: "Are you sure that you wish to delete this location?",
  selectStatesFetchFailed: "Unable to fetch states...",
  locationFormCreateTitle: "Create - Location",
  createLocationLabel: "Create Location",
  locationFormEditTitle: "Edit - Location",
  updateLocationLabel: "Update Location",

  // --- Sku Locations ---

  skuFormLocationTitle: "Locations",
  skuFormLocationLabel: "Locations",
  skuLocationNameLabel: "Location Name",
  skuLocationCompanyLabel: "Company",
  skuLocationAddress1Label: "Address 1",
  skuLocationCityLabel: "City",
  skuLocationStateLabel: "State",
  skuLocationTypeLabel: "Location Type",
  selectLocationFetchFailed: "Unable to fetch location types...",
  skuLocationDeleted: "Location deleted!",
  skuLocationRepeated:
    "The Location that you selected is already present for the current sku",
  skuLocationCreated: "New Location created!",
  selectLocationLabel: "Enter a location to search for",
  selectLocationTypeLabel: "Select a Location Type from the list",
  skuLocationCreateButtonLabel: "Add Location",
  skuLocationDeleteTitle: "Delete Location",
  skuLocationDeleteQuestion: "Are you sure you wish to delete this Location?",

  // --- Sku Attributes ---

  otherLabel: "Other",
  skuAttributesTitle: "Attributes",
  skuAttributeLabel: "Attribute",
  skuFormAttributeTitle: "Attributes",
  skuAttributeCreated: "New Attribute created!",
  attributeUpdated: "Attribute has been updated!",
  skuAttributeCreateButtonLabel: "Add Attribute",
  skuAttributeDeleteTitle: "Delete Attribute",
  skuAttributeDeleteQuestion: "Are you sure you wish to delete this Attribute?",
  skuAttributeTypeSelectLabel: "Attribute Type",
  skuAttributeEmpty: "The Attribute can't be empty. Please specify a value.",
  skuAttributeCreateMessage: "Select or type for creating a new Attribute",
  skuAttributeDeleted: "Attribute deleted!",
  endDateMustBeAfterStartDate: "End date must be after start date",

  // --- Sku Evaluations
  skuAssociationLabel: "SKU Association",
  directLabel: "Direct",
  indirectLabel: "Indirect",
  evaluationsLabel: "Evaluations",
  noEvaluationsLabel:
    "There are no associated Evaluations for the current Organization. Please change the Organization in the header if you believe this is incorrect.",

  // --- Sku Certificates
  skuCertificateAssociationLabel: "SKU Association",
  productCertificateAssociationLabel: "Product Association",
  certificateAssociationLabel: "Association",
  noCertificatesLabel:
    "There are no associated Certificates for the current Organization. Please change the Organization in the header if you believe this is incorrect.",

  // --- Sku Tags
  internalTags: "Internal Tags",
  aboutTags: "About tags",
  tagsAreInternalOnly:
    "Tags are internal only — learners never see them. They power filtering and reporting across the catalog.",
  noTagsAddedYet: "No tags added yet",
  addATag: "Add a tag",
  add: "Add",
  startTypingToSearchExistingTags: "Start typing to search existing tags. Enter to add.",
  removeTagName: "Remove tag {name}",
  tagNameAdded: "Tag {name} added",
  tagNameRemoved: "Tag {name} removed",
  tagNameIsAlreadyAdded: "Tag {name} is already added",
  tags: "Tags",

  // --- Sku Progression Logic
  defaultProgressionGates: "Default Progression Gates",
  addDefaultProgressionGate: "Add Default Progression Gate",
  editDefaultProgressionGate: "Edit Default Progression Gate",
  courseProgressionLogicTitle: "Course Progression Logic",
  gateTypeLabel: "Gate Type",
  promptLabel: "Prompt",
  labelTextLabel: "Label",
  dialogueTitleLabel: "Dialogue Title",
  courseProgressionRequiredResponseLabel: "Required Response",
  errorMessageField: "Error Message",
  courseProgressionGateCreateButtonLabel: "Add Course Progression Gate",
  progressionGateTypeLabel: "Gate Type",
  courseProgressionGateSaved: "Sku Progression Gate Saved!",
  courseProgressionGateUpdated: "Sku Progression Gate Updated!",
  courseProgressionGateDeleted: "The Gate type has been deleted.",
  courseProgressionGateDeleteModalTitle: "Delete Course Progression Gate Type",
  courseProgressionGateDeleteQuestion:
    "Are you sure you want to delete this progression gate?",
  courseProgressionGateModalTitle: "Add Course Progression Gate",
  editCourseProgressionGate: "Edit Course Progression Gate",
  deleteDefaultProgressionGateTitle: "Delete Default Progression Gate",
  deleteDefaultProgressionGateConfirmation:
    "Are you sure you want to delete this default progression gate?",
  progressionGateInheritedInfo:
    "This course is using inherited progression gate from the organization",
  progressionGateOverriddenInfo:
    "This course is using overridden progression gate",
  progressionGateDisabledInfo:
    "Course progression gate is disabled for this course",
  progressionGateOverrideCta: "Override Course Progression Gate",
  progressionGateDeactivateCta: "Deactivate Course Progression Gate",
  progressionGateDeactivated: "Course progression gate has been deactivated",
  progressionGateReactivated: "Course progression gate has been reactivated",
  reactivateProgressionGate: "Reactivate Course Progression Gate",
  deactivateProgressionGateConfirmation:
    "Are you sure you want to deactivate Progression Gate for this SKU?",
  progressionGatesAddCta: "Add Course Progression Gate",

  // --- Users ---
  user: "User",
  newUser: "New User",
  copySuccessMessage: "URL copied to clipboard.",
  copyFailedMessage: "Error. URL not copied to clipboard.",
  impersonationMessage: "Impersonation User",
  addEnrollment: "Add Enrollment",
  addEnrollmentFor: "Add Enrollment for {name}",
  enrollmentAdded: "The enrollment has been added.",
  willAppearInUserCoursesShortly:
    "It will appear in the User Courses list shortly.",
  bulkEnrollment: "Bulk Enrollment",
  enrollmentDetails: "Enrollment Details",
  selectUsers: "Select Users",
  selectedUsersCount: "{count} users selected",
  selectAtLeastOneUser: "Please select at least one user to enroll.",
  enrollUsers: "Enroll {count} Users",
  usersSelectedMessage: "Users selected successfully.",
  bulkEnrollmentCompleted: "Bulk Enrollment Completed",
  bulkRegistrationBackgroundNotice:
    "The registrations are being processed in the background and may take a few minutes to appear.",
  usersEnrolledSuccessfully: "Users have been enrolled successfully.",
  backToUsers: "Back to Users",
  selectOrganizationFirst: "Please select an organization to continue.",
  createLoginMessage: "Create User Login",
  markAsAttendedMessage: "Mark User as Attended",
  markUserAsAttendedTitle: "Mark {name} as Attended",
  markAsAttendedSaveButton: "Mark as Attended",
  markAsAttendedSuccessMessage: "The user has been marked as attended.",
  markAsAttendedSkuPlaceholder: "XXXX-XXX-XX-01",
  userAlreadyHasActiveRegistration:
    "User already has an active registration for this SKU",
  firstNameLabel: "First Name",
  lastNameLabel: "Last Name",
  userNameLabel: "User Name",
  emailLabel: "Email",
  phoneLabel: "Phone",
  userFormParentInstanceIdLabel: "Parent Instance ID",
  userFormExternalTitle: "External Info",
  userFormExternalIdLabel: "External User ID (Website)",
  externalUserId: "External User ID",
  userFormExternalUserNameLabel: "External User Name (Website)",
  userFormCreateButton: "Create User",
  rolesLabel: "Roles",
  roleLabel: "Role",
  createRole: "Create Role",
  updateRole: "Update Role",
  roleUpdated: "Role Updated",
  newRole: "New Role",
  externalRoles: "External roles",
  claims: "Claims",
  userFormUpdateButton: "Update User",
  mergeUsers: "Merge users",
  mergeUsersTitle: "Merge users {nameToDelete} and {nameToUpdate}",
  userLoadError: "Error loading user",
  userUpdated: "User successfully updated!",
  userCreateSuccessMessage: "User created successfully!",
  mergeUserToBeDeleted: "User to be deleted",
  mergeUserToMergeDataTo: "User to merge all data to",
  confirmOperation: "Confirm operation",
  confirmButton: "Confirm",
  areYouSureText: "Are you sure you want to make this change?",
  changeReasonLabel: "Change reason",
  changeReasonRequestText:
    "Please provide a brief explanation for why these changes are being made. We'll log this information in the event we need to reference it later.",
  mergeAreYouSureText: "Are you sure you want to merge selected users?",
  provideMergeReason:
    "Please provide a brief explanation for why these users are being merged. We'll log this information in the event we need to reference it later.",
  mergingReason: "Merging reason",
  changeReasonRequired: "Change reason is required to proceed",
  mergingReasonRequiredMessage: "Merging reason is required to proceed",
  externalSourceId: "External Source ID (Legacy System)",
  addSku: "Add Sku",
  yes: "Yes",
  no: "No",
  manage: "Manage",
  timeZoneLabel: "Time Zone",
  changingOrganizationIsDisabled:
    "Changing the Organization is disabled to prevent problems associated with moving data from one Organization to another.",
  organizationInheritedFromTheHeaderFilter:
    "Inherited from the header filters. To update the Organization, change the Organization in your header filters.",
  toChangeTheOrganizationClickIntoTheField:
    "To change the organization, set the Organization in the header, and click into the field. Please note, there could be unintended consequences of changing the Organization value.",
  clientUsersMessage: "Client users must be added in the Organization Portal",
  organizationUsersMessage: "Add a user to this Organization",
  userCredentials: "User Credentials",
  inheritedCredentialTooltip: "User Credential is set on User Account level",
  deleteUserCredential: "Delete User Credential",
  areYouSureToDeleteUserCredential:
    "Are you sure you want to delete this User Credential?",
  addUserCredential: "Add User Credential",

  // --- User SKUs ---
  userCoursesTitle: "User Courses",
  includedSkusTitle: "Included SKUs",
  listedLabel: "Listed",
  trial: "Trial",
  test: "Test",
  type: "Type",
  audit: "Audit",
  activityDate: "Activity Date",
  activityType: "Activity Type",
  activityEvent: "Activity Event",
  auditEvent: "Event",
  actor: "Actor",
  unknownActor: "Unknown",
  notSet: "(not set)",
  auditTimelinePartial:
    "Part of the audit timeline could not be loaded, so some entries may be missing.",

  // --- Tables ---

  tableNumSelected:
    "{numSelected, plural, one {# selected} other {# selected}}",
  tableDeleteTooltip: "Delete {num, plural, one {item} other {# items}}",
  tableEditTooltip: "Edit",
  tableRowsPerPage: "Rows per page",
  expand: "Expand",
  collapse: "Collapse",

  // --- Applications ---
  applicationsTitle: "Applications",

  // --- Application Users ---
  applicationUserAccessRemoved:
    "The user doesn't have access to the application anymore.",
  applicationUserAccessGiven: "The user has access to the application.",
  applicationUserGiveAccessButtonLabel: "Give Access",
  applicationUserRemoveAccessForApplicationTitle:
    "Remove Access for Application",
  applicationUserRemoveAccessForApplicationQuestion:
    "Are you sure you want to remove the access of this user to the application?",
  applicationUserRemoveAccessForApplicationButtonLabel: "Remove Access",

  applicationNameLabel: "Application Name",

  // -- Evaluations --
  evaluationCloneComfirmMessage:
    "Are you sure you want to clone this evaluation?",
  evaluationCloneLabel: "Clone Evaluation",
  evaluationTypeLabel: "Type",
  evaluationNameLabel: "Evaluation Name",
  evaluationDateLabel: "Evaluation Date",
  updateEvaluations: "Update Evaluations",
  updateEvaluationsWarning:
    "Do you want to update the cache with the links between skus and evaluations based on evaluations configuration?",

  scoreLabel: "Score",
  result: "Result",
  notYetGraded: "Not Yet Graded",
  submittedDate: "Submitted Date",
  examAttempts: "Exam Attempts",
  noExamAttemptsYet: "This user has not made any Exam attempts yet.",
  viewAttempt: "View Attempt",
  examNameLabel: "Exam Name",
  examAttemptResults: "Exam Attempt Results",
  examAttemptResultsTitle: "Exam Attempt Results for {name}",
  examAttemptDetails: "Exam Attempt Details",
  pass: "Pass",
  fail: "Fail",
  examAttemptsFor: "{name} Exam Attempts for <x>{examName}</x>",
  examAttemptsForTitle: "Exam Attempts for {name}",
  invalidateExam: "Invalidate Exam",
  invalidateExamAttempt: "Invalidate Exam Attempt",
  invalidateExamWarning:
    "Are you sure you want to invalidate this exam attempt? This will give user a new exam attempt.",
  pendingLabel: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
  cancelled: "Cancelled",
  submitGradingButton: "Submit Grading",
  gradingRequired: "You must grade each question",
  questionLabel: "Question",
  questionFeedbackLabel: "Question Feedback",
  questionTypeCategoryHeader: "Category Header",
  questionTypeFileUploadDocument: "File Upload - Document",
  questionTypeFileUploadImage: "File Upload - Image",
  questionTypeFileUploadVideo: "File Upload - Video",
  questionTypeMultipleAnswers: "Multiple Answers",
  questionTypeMultipleChoice: "Multiple Choice",
  questionTypeRating: "Rating",
  questionTypeText: "Text",
  feedbackRequired:
    "You must provide feedback if user response does not meet the requirements",
  feedbackFormLabel: "What feedback do you want to provide to the learner?",
  feedbackFormInfo:
    "The feedback you provide will be shown to learners on the. Exam Results page. Feedback is optional if the learner meets the requirements to earn credit for the question, and is required if they do not meet the requirements.",
  questionsCreatedOnLabel: "Created",
  questionsTypeLabel: "Question Type",
  questionsRatingSettingLabel: "Setting",
  questionsRequiredLabel: "Required",
  createAnotherQuestion: "Create another question",
  correctAnswerLabel: "Correct Answer",
  answersLabel: "Answers",
  insertAnswerPlaceholder: "Insert answer...",
  expectedAnswerLabel: "Expected answer",
  userAnswerLabel: "User answer",
  answerPlaceholder: "Enter an answer...",
  answersRequired: "Answers required",
  answersSequenceLabel: "Sequence",
  answersIsAnswerLabel: "Is\u00a0Answer?",
  answersIsDeletedLabel: "Is\u00a0Deleted?",
  questionLoadError: "Error when retrieving question",
  questionUpdated: "Question successfully updated!",
  questionCreated: "Question successfully created!",
  questionTypeShort:
    "{type, select, Text {TXT} CategoryHeader {CAT} Rating {RAT} MultipleChoice {MUL} MultipleAnswers {MULA} other {type}}",
  questionsManageRatingLink: "Manage Question Ratings",

  questionFormAddAnswerButton: "Add New Answer",
  questionFormAnswerTitle: "Correct Answer",
  questionFormUpdateButton: "Update Question",
  questionFormCreateButton: "Create Question",

  questionRatingsTitle: "Question Ratings",
  questionRatingNameLabel: "Rating name",
  questionRatingMinLabel: "Min Text",
  questionRatingMaxLabel: "Max Text",
  questionRatingCountLabel: "Count",
  questionRatingCreateButton: "Create Rating",
  questionRatingCreated: "Question rating successfully created!",

  questionDeleteTitle: "Delete Question",
  questionDeleteInfo: "Are you sure that you wish to delete this question?",
  editQuestionTitle: "Edit Question",
  noQuestionsAdded: "No questions added yet",
  questionDeleteWithEvaluationInfo:
    "This question is already in use in an Evaluation. Are you sure that you wish to delete this question?",
  questionCannotBeEdited:
    "This Question has more than 5 responses and can not be updated. Only Question Feedback can be edited.",

  evaluationsTypeLabel: "Type",
  evaluationDeletedInfo: "This evaluation has been deleted",

  evaluationLoadError: "Error retrieving evaluation",
  evaluationFormSkuAvailabilityOrSkuRequiredLabel:
    "One of the fields SKU is required or Sku Availability is required",
  evaluationFormCreateTitle: "New Evaluation",
  evaluationInactiveConfirmationMessage:
    "This Evaluation is not marked as Active, would you still like to create it?",
  evaluationFormActiveLabel: "Is Active",
  evaluationFormEvaluationStatusLabel: "Evaluation Status",
  evaluationEnablePrintReferenceLabel: "Enable Print Reference Exam",
  evaluationEnableReferenceLabel: "Enable Reference Exam",
  evaluationFormEvaluationTypeLabel: "EvaluationType",
  evaluationFormProductLabel: "Product",
  evaluationFormProductTypeLabel: "Product Type",
  evaluationFormProductYearLabel: "Product Year",
  evaluationFormProductVersionLabel: "Product Version",
  evaluationFormSkuLabel: "Sku",
  passingScoreLabel: "Passing Score",
  passingScoreValidationError:
    "Value must be no less than 0 and no greater than 100.",
  evaluationFormAttemptsAllowedLabel: "Attempts Allowed",
  evaluationFormDayAfterCourseLabel: "Survey Days After",
  evaluationFormQuestionsLabel: "Questions",
  evaluationFormQuestionSearchPlaceholder: "Search for Question to add...",
  evaluationFormQuestionSearchMoreResults:
    "Displaying the first {filtered} results, please type more to refine your search...",
  evaluationFormAddQuestionButton: "Add",
  evaluationFormCreateQuestionButton: "Create New Question",
  evaluationFormImportQuestionsButton: "Import Questions",
  evaluationFormCreateButton: "Create Evaluation",
  evaluationFormUpdateButton: "Update Evaluation",
  evaluationFormImportedQuestionsWarning:
    "You have imported questions using an AI feature and AI can commit mistakes. Please, review the information above before continuing. If you don't click on 'Update Evaluation', your imported questions will not be saved.",
  evaluationTypeSetMessage:
    "Select the evaluation type before adding questions.",
  duplicateEvaluationDetectedTitle: "Duplicate Evaluation Detected",
  duplicateEvaluationDetectedMessage:
    "We are unable to save this Evaluation because we detected a duplicate Evaluation that already exists in the system.",
  duplicateEvaluationDetectedInstruction:
    "You can close this dialogue window and modify the configuration of the Evaluation, or click on the link below and review the existing Evaluation.",
  clickHereToOpenExistingEvaluation:
    "Click here to open the existing Evaluation in a new tab",

  evaluationDeleteTitle: "Delete Evaluation",
  evaluationDeleteInfo: "Are you sure that you wish to delete this evaluation?",
  correctLabel: "Correct",
  incorrectLabel: "Incorrect",
  questionSequence: "Question {sequence}: ",
  userResponseLabel: "User Response",
  doesResponseMeetRequirements: "Does the response meet the requirements?",
  meetRequirements: "Meets Requirements",
  doesNotMeetRequirements: "Does Not Meet Requirements",
  browserDoesNotSupportVideo:
    "Your browser does not support the video tag, you can ",
  userCannotViewPdf:
    "Your browser does not support the embedded PDF document, you can ",
  downloadHere: "download it here",
  userAnswerImageAlt: "User answer image",
  printReferenceExamDisabledTooltip:
    "The Enable Print Reference Exam feature has been disabled for this organization and you are not able to enable the Print Reference Exam CTA for this Exam.",
  // --- Selects ---

  organizationBreadcrumbsFetchFailed: "Unable to fetch organizations...",
  selectApplicationFetchFailed: "Unable to fetch application list...",
  selectQuestionTypeFetchFailed: "Unable to fetch question types...",
  selectRatingSettingFetchFailed: "Unable to fetch rating settings...",
  selectProductFetchFailed: "Unable to fetch product list...",
  selectProductTypeFetchFailed: "Unable to fetch product type list...",
  selectResourceLibraryItemTypeFetchFailed:
    "Unable to fetch resource library list...",
  selectResourceLibraryFailed: "Unable to fetch resource library list...",
  selectEvaluationTypeFetchFailed: "Unable to fetch evaluation type list...",
  selectInflectionPointsFetchFailed:
    "Unable to fetch inflection points list...",
  selectSkuFormatFetchFailed: "Unable to fetch sku format list...",
  selectSkuAvailabilityFetchFailed: "Unable to fetch sku availability list...",
  selectSkuStatusFetchFailed: "Unable to fetch sku status list...",
  selectProductYearFetchFailed: "Unable to fetch product year list...",
  selectProductVersionFetchFailed: "Unable to fetch product version list...",
  selectParentUserSkuFetchFailed: "Unable to fetch parent user sku list...",
  selectSkuFetchFailed: "Unable to fetch Sku list...",
  selectCourseTitleFetchFailed: "Unable to fetch course title list...",
  selectCorporateEntityFetchFailed:
    "Unable to fetch corporate entities type list...",
  selectDeliveryMethodFetchFailed: "Unable to fetch content delivery list...",
  selectAdvancedPreparationFetchFailed:
    "Unable to fetch advanced preparations list...",
  selectTaxClassFetchFailed: "Unable to fetch tax classes list...",
  selectProfessionFailed: "Unable to fetch Profession list...",
  selectSkuRelationshipFetchFailed: "Unable to fetch SKU Relationships list...",
  selectTimeZoneFetchFailed: "Unable to fetch Time Zones list...",
  // --- Bulk ---

  bulkUploadCancelled: "CSV import cancelled",
  bulkUploadNetworkError:
    "There was an error while uploading your file. Please try again.",
  bulkUploadFileContentError: "Invalid CSV file.",
  bulkUploadError: "Error: {value} is not a valid {field}",

  // --- Content Rules ---

  addRuleButton: "Add Rule",
  excludeLabel: "Exclude",
  ruleDetailsLabel: "Rule Details",
  addFilterButton: "Add Filter",
  availableLabel: "Available",
  selectedLabel: "Selected",
  moveAllToSelected: "Move all to selected",
  moveCheckedToSelected: "Move checked to selected",
  moveCheckedToAvailable: "Move checked to available",
  moveAllToAvailable: "Move all to available",
  ruleUpdatedMessage: "Rule updated!",
  oRLabel: "or",
  ruleNameLabel: "Rule Name",
  createRuleTitle: "Add Rule",
  createRuleButton: "Add Rule",
  updateRuleTitle: "Edit Rule",
  updateRuleButton: "Update Rule",
  skuRuleTypeTitle: "Rule Type *",
  productTypeLabel: "Product Type",
  formatLabel: "Format",
  availabilityLabel: "SKU Availability",
  statusLabel: "Status",
  versionLabel: "Version",
  yearLabel: "Year",
  saveFilterLabel: "Save Filter",
  instanceLabel: "Instance",
  clientLabel: "Client",
  catalogCreated: "Catalog successfully created!",
  seriesLabel: "Series",
  seriesLoadError: "Error retrieving series",
  modulesLabel: "Modules",
  moduleLabel: "Module",
  moduleQuantityLabel: "Quantity",
  seriesAddModuleButton: "Add Module",
  seriesAddRequirementButton: "Add Requirement",
  moduleFormCreateButton: "Create Module",
  moduleFormUpdateButton: "Update Module",
  moduleDeleteTitle: "Delete Module",
  moduleDeleteQuestion: "Are you sure that you want to delete this module?",
  buildCatalog: "Build Catalog",
  buildCatalogWarning:
    "Do you want to rebuild the catalog, memberships and packages content based on the rules defined?",
  syncCatalog: "Sync Catalog",
  syncCatalogWithCrm: "Sync Catalog with CRM",
  syncCatalogWarning:
    "Do you want to sync the skus from CRM, so they become available in KONE? This option will also start a build catalog process after this sync completes.",
  flushRedisCache: "Flush Redis Cache",
  flushRedisCacheWarning:
    "Do you want to flush all Redis cache? This will clear all cached data across all services and may temporarily impact performance.",
  flushRedisCacheSucceeded: "Redis cache flushed on all {total} node(s).",
  flushRedisCachePartial:
    "Redis cache flushed on only {flushed} of {total} node(s). Check the logs for the failed nodes.",
  flushRedisCacheAllNodesFailed:
    "Redis cache flush failed on all {total} node(s). Check the logs.",
  flushRedisCacheFailed: "Failed to flush the Redis cache.",
  resyncSettingsCache: "Resync Settings Cache",
  resyncSettingsCacheWarning:
    "Do you want to resync all settings cache? This will rebuild the settings cache for all organizations and may take several minutes.",
  resyncDesignations: "Resync Designations",
  resyncDesignationsWarning:
    "Do you want to resync Designations? This will publish all Designation records from the Certificate master table to dependent service caches.",
  resyncLocations: "Resync Locations",
  resyncLocationsWarning:
    "Do you want to resync Locations? This will publish all Location records from the Certificate master table to dependent service caches.",
  resyncLicensureBodies: "Resync Licensure Bodies",
  resyncLicensureBodiesWarning:
    "Do you want to resync Licensure Bodies? This will publish all Licensure Body records from the Certificate master table to dependent service caches.",
  resyncDesignationsTriggered:
    "Designation sync has been triggered. Records will be propagated to all dependent services shortly.",
  resyncLocationsTriggered:
    "Location sync has been triggered. Records will be propagated to all dependent services shortly.",
  resyncLicensureBodiesTriggered:
    "Licensure Body sync has been triggered. Records will be propagated to all dependent services shortly.",

  // -- Resource

  addPicture: "Add Picture",
  removePicture: "Remove Picture",
  facultyCreated: "Faculty successfully created!",
  facultyUpdated: "Faculty successfully updated!",
  facultyLabel: "Faculty",
  facultyRoles: "Faculty Role(s)",
  resourceDeleteTitle: "Delete Faculty",
  resourceDeleteInfo: "Are you sure that you wish to delete this Faculty?",
  facultyFormUpdateButton: "Update Faculty",
  facultyFormCreateTitle: "New Faculty",
  facultyFormCreateButton: "Create Faculty",
  crmEmailLabel: "CRM Email",
  crmIdLabel: "CRM ID",
  koneUser: "KONE User",
  facultyCantBeDeletedBecauseAssociatedWithSkus:
    "This Faculty cannot be deleted because it is associated with courses",
  facultyCantBeDeletedBecauseAssociatedToUser:
    "This Faculty cannot be deleted because it is associated to a Faculty user",
  rootOrganizationIsNotAllowedFacultyError:
    "Please, select an Organization at the header to create a Faculty",

  // -- Products

  productLabel: "Product",
  productTitleLabel: "Title",
  productUrlPathLabel: "URL Path",
  productCreated: "Product successfully created!",
  productUpdated: "Product successfully updated!",
  productLoadError: "Error retrieving product",
  productDeleteTitle: "Delete Product",
  productDeleteInfo: "Are you sure that you wish to delete this product?",
  productFormCreateButton: "Create Product",
  productFormUpdateButton: "Update Product",
  productRelatedSkusLabel: "Related SKUs",
  productManageVersionsLink: "Manage Versions",

  productVersionsTitle: "Product Versions",
  productVersionCreateButton: "Create Product Version",
  productVersionDeleteTitle: "Delete Product Version",
  productVersionDeleteInfo:
    "Are you sure that you wish to delete this product version?",
  productVersionUpdateButton: "Update Product Version",
  productVersionCreated: "Product Version Created!",
  productVersionUpdated: "Product Version Updated!",
  productVersionDeleted: "Product Version Deleted!",

  // --- SKUs ---

  skuLabel: "SKU",
  skuCloneLabel: "Clone Sku",
  skuCloneConfirmationMessage:
    "Please confirm you wish to clone this SKU. Please note, SKUs cannot be deleted if you clone a SKU by mistake",
  skuTitleLabel: "Title",
  skuProductLink: "This SKU is part of product {productLink}",
  skuAvailabilityLabel: "Sku Availability",
  skuStatusLabel: "Sku Status",
  skuProfessionLabel: "Profession",
  approvalStatusLabel: "Approval Status",
  activeApproval: "Active Approval",
  expiredApproval: "Expired Approval",
  futureApproval: "Future Approval",
  skuFormCreateButton: "Create SKU",
  skuFormUpdateButton: "Update SKU",
  skuSavedMessage: "The Sku was saved correctly!",
  skuCloneError:
    "Error trying to clone the sku, please try again or contact to the IT team",

  skuFormDetailsTitle: "SKU Details",
  skuFormTitleLabel: "Title",
  skuFormDescriptionLabel: "Description",
  skuFormCreditsLabel: "Total Credits",
  skuFormCreditLimitLabel: "Credit Limit",
  skuFormPriceLabel: "Price",
  skuFormMemberPriceLabel: "Member Price",
  skuFormSequenceLabel: "Sequence",
  skuFormProductLabel: "Product",
  createSku: "Create Sku",
  skuFormSkuFormatLabel: "Sku Format",
  skuFormProductVersionLabel: "Product Version",
  skuFormProductYearLabel: "Product Year",
  skuFormSkuStatusLabel: "Sku Status",
  publish: "Publish",
  lastModified: "Last modified",
  modifiedBy: "Modified by",
  skuFormEventDateLabel: "Event Date",
  skuFormEventStartDateLabel: "Event Start Date",
  skuFormEventEndDateLabel: "Event End Date",
  eventStartDateCannotBeLaterThanEventEndDate:
    "Event Start Date cannot be later than Event End Date",
  fromLabel: "From",
  toLabel: "To",
  releaseDateErrorMessage:
    "Release Date must be less than or equal to Expiration Date.",
  expirationDateErrorMessage:
    "Expiration Date must be less than or equal to Offline Date.",
  offlineDateErrorMessage:
    "Offline Date must be greater than or equal to Expiration Date or greater than Release Date.",
  skuFormExpirationDateLabel: "Expiration Date",
  skuFormReleaseDateLabel: "Release Date",
  skuFormOfflineDateLabel: "Offline Date",
  skuFormCreditSubmissionExpirationDateLabel:
    "Credit Submission Expiration Date",
  skuFormCorporateEntityLabel: "Corporate Entity",
  skuFormAdvancedPreparationsLabel: "Advanced Preparations",
  skuFormTaxClassLabel: "Tax Class",
  skuFormDirectUrlLabel: "Direct URL's",
  skuFormLatestVersionSkuIdLabel: "Latest Version Sku Id",
  skuFormAdvancedPreparationLabel: "Advanced Preparations",
  generateLabel: "Generate",
  skuFormAutoComplete: "Auto Complete",
  skuFormAutoCompleteTooltip:
    "Please select Product Format to enable auto-complete feature",
  skuFormSelectTargetPageLabel: "Select Target Page",

  skuContentRulesTitle: "SKU Rules",
  skuFormHasChildLabel: "Has Includes or Excludes?",
  accordionSkuContentRulesDisabled:
    'The SKU has to have the "Has Includes or Excludes?" checkbox set on true',
  skuFormHasChildWarningTitle: "Update SKU",
  skuFormHasChildWarningQuestion:
    'Are you sure you want to change the "Has Includes or Excludes?" value? If you continue, all the SKU content rules will be deleted.',
  skuRuleDetailsError: "Error retrieving sku rule details",

  skuRuleDeleteTitle: "Delete SKU Rule",
  skuRuleDeleteQuestion: "Are you sure you want to delete this rule?",
  skuRuleProductFilterDeleteTitle: "Delete SKU Rule Product Filter",
  skuRuleProductFilterDeleted: "SKU Rule Product Filter Deleted!",
  skuRuleProductFilterCreateTitle: "Create SKU Rule Product Filter",
  skuRuleOrganizationFilterDeleteTitle: "Delete Organization Based Filter",
  skuRuleFilterDeleteQuestion: "Are you sure you want to delete this filter?",
  skuRuleOrganizationFilterDeleted: "Organization Based Filter Deleted!",
  skuRuleOrganizationFilterCreateTitle: "Create Organization Based Filter",
  skuRuleSeriesFilterCreateTitle: "Create SKU Rule Series Filter",
  skuRuleSkuContentFilterDeleteTitle: "Delete SKU Content Based Filter",
  skuRuleSkuContentFilterDeleted: "Sku Content Based Filter deleted!",
  skuRuleSkuContentFilterCreateTitle: "Create Sku Content Based Filter",

  skuRuleTypeLabel:
    "{name, select, Sku {SKU List} SkuContent {SKU Content Based Filter} Product {Product Based Filter} Profession {Profession Based Filter} Series {Series Based Filter} Organization {Organization Based Filter} Tag {Tag Based Filter} other {type}}",

  skuRuleBehaviorLabel: "Rule Behavior",
  skuRuleIncludeLabel: "Include",
  skuRuleIncludeHint: "Adds matching content to the catalog",
  skuRuleExcludeLabel: "Exclude",
  skuRuleExcludeHint: "Removes matching content from the catalog",

  skuRuleAccessTypeLabel: "Access Type",
  skuRuleAccessTypeOpenLabel: "Open",
  skuRuleAccessTypeOpenHint: "Learners can register for free",
  skuRuleAccessTypeGatedLabel: "Gated",
  skuRuleAccessTypeGatedHint: "Learners must meet criteria to access",
  skuRuleAccessTypeDisabledTooltip:
    "Access Type is disabled because Membership Gated Access is not enabled for this organization.",

  skuUpdatedMessage: "SKU successfully updated!",
  minPriceMessage: "Min. Price",
  maxPriceMessage: "Max. Price",
  totalCreditsMinMessage: "Min. Credits",
  totalCreditsMaxMessage: "Max. Credits",

  crmOrderName: "Crm Order Name",
  isTestLabel: "Test Registration",
  isTestHelperText:
    "Test registrations generate certificates but do not trigger credit submissions",
  isTestDraftHelperText: "Auto-enabled because SKU status is Draft",

  // --- Sku Format ---

  regexValidationsTitle: "Regex Validations",
  regexValidationNameLabel: "Validation Rule Name",
  regexValidationValueLabel: "Regex",
  regexValidationMessageLabel: "Error Message",
  regexValidationCreateTitle: "Add Validation",
  regexValidationUpdateTitle: "Edit Validation",
  regexValidationCreateButton: "Add Validation",
  regexValidationCreated: "Regex Validation Created!",
  regexValidationUpdated: "Regex Validation Updated!",
  regexValidationCredentialsColumnLabel: "Credentials",
  regexValidationCredentialsColumnTooltip:
    "How many credentials use this validation",
  regexValidationCredentialsFilterLabel: "Credentials",
  regexValidationCredentialsTitle: "Credentials using this validation",
  regexValidationCredentialLabel: "Credential",
  regexValidationAppliedThroughLabel: "Applied",
  regexValidationAppliedByDefault: "Default",
  regexValidationAppliedByOrganizations:
    "{count, plural, one {# organization} other {# organizations}}",
  regexValidationSkippedByOrganizations:
    "{count, plural, one {# organization overrides this} other {# organizations override this}}",
  regexValidationSkippedByOrganizationsTooltip:
    "Their own copy of the question points at another validation, or at none, so this one is never enforced for them.",
  regexValidationInvalidPatternError:
    "This is not a valid regular expression.",
  regexValidationDelimiterError:
    "Enter the pattern only - don't wrap it in / ... /i delimiters.",
  skuFormatsTitle: "Sku Formats",
  skuFormatLabel: "Sku Format",
  skuFormatAcronymLabel: "Acronym",
  skuFormatCreateButton: "Create Sku Format",
  skuFormatDeleteTitle: "Delete Sku Format",
  skuFormatDeleteInfo: "Are you sure that you wish to delete this Sku format?",
  skuFormatUpdateButton: "Update Sku Format",
  skuFormatCreated: "Sku Format Created!",
  skuFormatUpdated: "Sku Format Updated!",
  skuFormatDeleted: "Sku Format Deleted!",
  skuFormatDeletedSaveFailed: "Sku Format save failed",
  startDateLabel: "Start Date",
  endDateLabel: "End Date",
  completionDateLabel: "Completion Date",
  registrationDateLabel: "Registration Date",
  // --- Resource Libraries ---

  resourceLibraryListNameLabel: "Library",
  resourceLibraryListApplicationLabel: "Application",
  resourceLibraryFormPathLabel: "Path",
  resourceLibraryFormContentNameLabel: "Content Name",
  resourceLibraryFormUpdateButton: "Update Resource Library",
  resourceLibraryCreated: "Resource Library successfully created!",
  resourceLibraryUpdated: "Resource Library successfully updated!",
  resourceLibraryLoadError: "Error retrieving Resource Library",
  resourceLibraryDeleteTitle: "Delete Resource Library",
  resourceLibraryDeleteInfo:
    "Deleting a Resource Library will remove all Library Items as well. Do you want to delete this Resource Library?",
  resourceLibraryFormCreateButton: "Create Resource Library",
  resourceLibraryItemLoadError: "Error loading Resource Library Item",
  resourceLibraryFormAddItemButton: "Add Item",
  resourceLibraryItemListNameLabel: "Name",
  resourceLibraryItemListResourceTypeLabel: "Resource Type",
  resourceLibraryItemCreated: "Resource Library Item successfully created!",
  resourceLibraryFormLibraryNameLabel: "Library Name",
  resourceLibraryFormItemTypeNameLabel: "Resource Type Item",
  publicationDate: "Publication Date",
  resourceLibraryFormSequenceLabel: "Sequence",
  resourceLibraryItemListLabel: "Resource Library Items",
  resourceLibraryFormCreateItemButton: "Create Library Item",
  resourceLibraryFormUploadRequiredLabel: "A valid file is required",
  resourceLibraryFormUploadFileTypeErrorLabel:
    ".exe is not an accepted file type. Please attach a different file.",
  resourceLibraryDetailsNameLabel: "Name",
  resourceLibraryDetailsLibraryNameLabel: "Library Name",
  resourceLibraryDetailsTypeLabel: "Resource Item Type",
  resourceLibraryDetailsSequenceLabel: "Sequence",
  resourceLibraryItemDeleteTitle: "Delete Resource Library Item",
  resourceLibraryItemDeleteInfo:
    "Do you want to delete this Resource Library Item?",
  resourceLibraryItemUpdated: "Resource Library Item successfully updated!",
  resourceLibraryItemFormUpdateButton: "Update Resource Library Item",
  resourceLibraryItemProfessionListNameLabel: "Profession",
  resourceLibraryItemProfessionListLabel: "Professions Add/Delete",
  resourceLibraryFormAddItemProfessionButton: "Add Profession",
  resourceLibraryItemProfessionCreated:
    "Resource Library Item Profession successfully created!",
  resourceLibraryFormCreateItemProfessionButton: "Add Profession",
  resourceLibraryItemAttributeListNameLabel: "Topic",
  resourceLibraryItemAttributeListLabel: "Topics Add/Delete",
  resourceLibraryFormAddItemAttributeButton: "Add Topic",
  resourceLibraryItemAttributeCreated:
    "Resource Library Item Topic successfully created!",
  resourceLibraryFormCreateItemAttributeButton: "Add Topic",
  resourceLibraryFormAttributeLabel: "Topic",
  resourceLibraryNoTopicsOATConfigured:
    "Topics attribute type is not configured for this organization. Please configure it in the Attributes section.",
  skuActionsLabel: "Actions",

  // sku contents
  skuContentsTitle: "SKU Contents",
  accordionSkuContentsDisabled:
    "Only available for Memberships, Catalog and Package SKUs",
  skuContentMinPricePlaceholder: "Min Price",
  skuContentMaxPricePlaceholder: "Max Price",
  skuContentPriceLabel: "Price",
  skuContentAccessTypeLabel: "Access Type",

  // sku relationships
  skuRelationshipsTitle: "SKU Relationships",
  autoRegisterTitle: "Auto Register",
  suggestedCoursesTitle: "Suggested Courses",
  includedInTitle: "Included In",
  containsTitle: "Contains",
  selectRelationshipTypeMessage:
    "Select a relationship type to display the options",
  addSkuRelationshipButton: "ADD SKU RELATIONSHIP",
  skuRelationShipSkuTitleLabel: "Course Title",
  skuRelationShipSkuNameLabel: "SKU",
  skuRelationShipSkuDeleteTitle: "Delete SKU Relationship",
  skuRelationShipSkuDeleteQuestion:
    "Are you sure you wish to delete this relationship?",
  skuRelationshipCreated: "New SKU Relationship created!",
  skuRelationShipDeleted: "The SKU Relationship has been deleted.",
  skuRelationshipTitle: "Sku Relationship",
  skuRelationshipSaveButtonLabel: "Save",
  skuRelationshipSelfReferenceError: "A SKU cannot be related to itself.",
  bidirectional: "Bidirectional",

  //sku links
  skuLinks: "SKU Links",
  targetPage: "Target Page",
  fileTypePng: "File Type: PNG",
  downloadQrCode: "Download QR Code",
  skuLinksAreAppInstanceSpecific:
    "SKU Links are Application Instance specific.",
  setAppInstanceToSeeSkuLinks:
    "Please set the applicable Application and Application Instance in the header to see the SKU Links.",

  //sku knowledge levels
  selectKnowledgeLevelsFetchFailed: "Unable to fetch Knowledge Levels list...",
  skuKnowledgeLevelDeleteQuestion:
    "Are you sure you wish to delete this Knowledge Level?",
  skuKnowledgeLevelDeleted: "The Knowledge Level has been deleted.",
  skuKnowledgeLevelCreated: "New Knowledge Level created!",
  skuKnowledgeLevelRepeated:
    "The Knowledge Level that you selected is already present for the current sku",
  skuKnowledgeLevelLabel: "Knowledge Levels",
  skuKnowledgeLevelTitle: "Knowledge Level",
  selectKnowledgeLevelLabel: "Select Knowledge Level from the list",
  skuKnowledgeLevelEmpty:
    "The knowledge level can't be empty. Please specify a value",
  skuKnowledgeLevelCreateButtonLabel: "Add Knowledge Level",
  skuKnowledgeLevelSaveButtonLabel: "Save Sku Knowledge Level",
  skuFormKnowledgeLevelTitle: "Knowledge Levels",
  skuKnowledgeLevelDeleteTitle: "Delete Knowledge Level",

  //sku delivery methods
  invalidVimeoFormat: "Invalid Vimeo URL or ID",
  uploadZipFile: "Upload zip file",
  addVideoFile: "Add video file",
  addPdfFile: "Add PDF file",
  skuFormDeliveryMethodTitle: "Content Delivery",
  contentDeliveryKey: "Content Delivery Key",
  skuFormDeliveryMethodSequenceLabel: "Sequence",
  displayText: "Display Text",
  courseActionsButtonText: "Course Actions Button Text",
  pageContent: "Page Content",
  skuDeliveryMethodTitle: "Content Delivery",
  contentType: "Content Type",
  validation: "Validation",
  missingKey: "Missing key",
  previewUnavailable: "This content could not be previewed",
  previewDeliveryMethod: "Preview: {name}",
  noContentAvailable: "No content available for preview",
  courseActions: "Course Actions",
  skuDeliveryMethodSaveButtonLabel: "Create Sku Content Delivery",
  skuDeliveryMethodUpdateButtonLabel: "Update Sku Content Delivery",
  skuDeliveryMethodCreateButtonLabel: "Add Content",
  skuDeliveryMethodCreated: "New Content Delivery created!",
  skuDeliveryMethodUpdated: "Content Delivery updated!",
  skuDeliveryMethodDeleteQuestion:
    "Are you sure you wish to delete this Content Delivery?",
  skuDeliveryMethodDeleteTitle: "Delete Content Delivery",
  skuDeliveryMethodDeleted: "The Content Delivery has been deleted",
  displayTextEmptyMessage: "Display Text must have a value",
  urlEmptyMessage: "Url field is empty",

  //sku learning levels
  selectLearningLevelsFetchFailed: "Unable to fetch Learning Levels list...",
  skuLearningLevelDeleteQuestion:
    "Are you sure you wish to delete this Learning Level?",
  skuLearningLevelDeleted: "The Learning Level has been deleted.",
  skuLearningLevelCreated: "New Learning Level created!",
  skuLearningLevelRepeated:
    "The Learning Level that you selected is already present for the current sku",
  skuLearningLevelLabel: "Learning Levels",
  skuLearningLevelCreateButtonLabel: "Add Learning Level",
  skuFormLearningLevelTitle: "Learning Levels",
  skuFormLearningLevelLabel: "Learning Levels",
  selectLearningLevelLabel: "Select Learning Level from the list",
  skuLearningLevelDeleteTitle: "Delete Learning Level",

  //sku study fields
  skuStudyFieldDeleteTitle: "Delete Study Field",
  skuStudyFieldDeleteQuestion:
    "Are you sure you wish to delete this Study Field?",
  skuStudyFieldDeleted: "The Study Field has been deleted.",
  skuStudyFieldLabel: "Select Study Field from the list",
  credits: "Credits",
  skuStudyFieldCreated: "New Study Field created!",
  skuStudyFieldRepeated:
    "The Study Field that you selected is already present for the current sku",
  skuStudyFieldCreditsOverpassed:
    "The credits for Study Fields can't overpass the amount of credits defined for the current sku",
  skuStudyFieldCreateButtonLabel: "Add Study Field",
  skuFormStudyFieldTitle: "Study Fields",
  skuCreditsLowerThanSkuStudyFieldCredits:
    "The Sku credits can't be lower than the sum of credits assign to Study Fields",
  skuCreditsBehaviourMessage: "Total Credits",

  //sku resources
  skuFacultyTitle: "Faculty",
  skuFacultyCreateButtonLabel: "Add Faculty",
  editFaculty: "Edit Faculty",
  deleteFaculty: "Delete Faculty",
  linkUserToFaculty: "Link a user to the Faculty record",
  unlinkFacultyAndUser: "Unlink the Faculty record and the User",
  areYouSureToUnlinkFaculty:
    "Are you sure you want to unlink this User from this Faculty record? The User will lose access to the Faculty Portal.",
  skuFacultyTypesTitle: "Faculty Types",
  selectResourceTypesFetchFailed: "Unable to fetch Faculty Types",
  skuFacultyTypeLabel: "Faculty Type",
  skuFacultyMemberLabel: "Faculty Member",
  skuFacultyDeleted: "The Faculty has been deleted",
  skuFacultyCreated: "New Faculty created!",
  skuResourceEmpty: "The faculty can't be empty. Please specify a value",
  skuFacultyDeleteTitle: "Delete Faculty from the Sku",
  skuFacultyDeleteQuestion: "Are you sure you wish to delete this Faculty?",
  skuResourceCreateMessage: "Select or type for creating a new faculty",
  skuFacultyRepeated:
    "There's already a faculty with the values that you have specified",
  prefixLabel: "Prefix",
  middleNameLabel: "Middle Name",
  suffixLabel: "Suffix",

  //sku major topics
  skuFormMajorTopicTitle: "Major Topics",
  skuMajorTopicCreateButtonLabel: "Add Major Topic",
  skuMajorTopicCreateButton: "Create Major Topic",
  skuMajorTopicDeleteQuestion:
    "Are you sure you wish to delete this Major Topic?",
  skuMajorTopicDeleteTitle: "Delete Major Topic",
  skuMajorTopicDeleted: "The Major Topic has been deleted",
  majorTopicPlaceholder: "Enter a major topic description...",
  professionLabel: "Profession",
  accreditationBodyLabel: "Accreditation Body",

  // --- Accreditation: Licensure Bodies ---
  licensureBodies: "Licensure Bodies",
  accreditationChain: "Accreditation Chain",
  accreditationChainEmpty:
    "This licensure body does not participate in any accreditation chain.",
  editLicensureBody: "Edit Licensure Body",
  licensureBodyUpdated: "Licensure body successfully updated!",
  licensureBodyNotAccessible:
    "This organization doesn't have access to this licensure body",
  backToLicensureBody: "Back to licensure body",

  // --- Accreditation: Submission Authorities ---
  submissionAuthorities: "Submission Authorities",
  editSubmissionAuthority: "Edit Submission Authority",
  submissionAuthorityUpdated: "Submission authority successfully updated!",
  submissionAuthorityNotAccessible:
    "This organization doesn't have access to this submission authority",
  backToSubmissionAuthority: "Back to submission authority",
  uploadSubmissionStatusAvailableLabel: "Upload Submission Status Available",
  submissionCutOffDaysLabel: "Submission Cut-Off Days",

  // --- Accreditation: Licenses ---
  licensesLabel: "Licenses",
  licenseIdLabel: "License ID",
  allProfessions: "All Professions",
  professions: "Professions",
  accreditationBody: "Accreditation Body",
  submissionAuthority: "Submission Authority",
  skuValidationLabel: "Sku Validation",
  expiredChipLabel: "Expired",
  groupByLicensureBodyLabel: "By Licensure Body",
  groupByAccreditationBodyLabel: "By Accreditation Body",
  groupBySubmissionAuthorityLabel: "By Submission Authority",
  alwaysShown: "Always Shown",
  licenseQuestions: "License Questions",
  defaultValueLabel: "Default Value",
  validationRule: "Validation Rule",
  licenseNotAccessible: "This organization doesn't have access to this license",
  selectABrandOrganization: "Select a Brand Organization",
  editLicenseQuestion: "Edit License Question",
  licenseQuestionDeleteOverride: "Delete License Question Override",
  licenseQuestionDeleteQuestion:
    "Are you sure you want to delete this override? The license question will revert to the Knowfully Learning Group values.",
  licenseQuestionSaved: "License question saved",
  licenseQuestionDeleted: "License question override deleted",
  majorTopicEmptyProfessionMessage:
    "You can leave this field empty if don't want to set a value of profession",
  skuMajorTopicCreated: "Major topic created!",
  skuDirectLinkUrlLabel: "Direct Link URL",
  skuMajorTopicTitle: "Major Topics",

  // --- Accreditation: Requirement Sets and Requirements ---
  requirementLabel: "Requirement",
  requirementSetNotFound: "This requirement set could not be found",
  requirementNotFound: "This requirement could not be found",
  activeRequirementSet: "Active Requirement Set",
  licensureRequirements: "Licensure Requirements",
  backToLicense: "Back to {license}",
  searchRequirementName: "Search requirement name...",
  allLabel: "All",
  noneLabel: "None",
  effectiveLabel: "Effective",
  fromDateOngoing: "{date} - ongoing",
  carryoverAllowed: "Carryover Allowed",
  cycleConfiguration: "Cycle Configuration",
  creditConfiguration: "Credit Configuration",
  accreditorsLabel: "Accreditors",
  cycleLength: "Cycle Length",
  cycleType: "Cycle Type",
  dateScheme: "Date Scheme",
  earnPeriodsPerReportPeriod: "Earn Periods per Report Period",
  gracePeriod: "Grace Period",
  creditUnit: "Credit Unit",
  minimumIncrement: "Minimum Increment",
  sameCourseRepeatAllowed: "Same-Course Repeat Allowed",
  documentationRetention: "Documentation Retention",
  roundingDirection: "Rounding Direction",
  noCycleConfiguration: "This requirement set has no cycle configuration",
  noCreditConfiguration: "This license has no credit configuration",
  noAccreditors: "This license has no accreditors",
  noRequirements: "There are no requirements for this license",
  noMatchingRequirements: "No requirements match the current filters",
  requirementsLoadFailed: "The licensure requirements could not be loaded",
  activeRequirementSetLoadFailed: "Could not be loaded",
  monthsCount: "{count, plural, one {# month} other {# months}}",
  daysCount: "{count, plural, one {# day} other {# days}}",
  minutesCount: "{count, plural, one {# minute} other {# minutes}}",
  hoursCount: "{count, plural, one {# hour} other {# hours}}",
  yearsCount: "{count, plural, one {# year} other {# years}}",
  dueDateOddYears: "{date} of odd-numbered years",
  dueDateEvenYears: "{date} of even-numbered years",
  dueDateBirthDate: "The date of birth",
  dueDateLastDayBirthMonth: "The last day of the birth month",
  dueDateLicenseIssueDate: "The anniversary of the license issue date",
  dueDateLastDayLicenseMonth: "The last day of the license issue month",
  ruleType: "Rule Type",
  measureType: "Measure Type",
  measureLabel: "Measure",
  recurrenceType: "Recurrence Type",
  recurrenceLabel: "Recurrence",
  recurrenceIntervalCycles: "Recurrence Interval Cycles",
  effectiveStartDate: "Effective Start Date",
  effectiveEndDate: "Effective End Date",
  isAdditive: "Is Additive",
  additiveLabel: "Additive",
  isPerEarnPeriod: "Is Per Earn Period",
  sortOrder: "Sort Order",
  requirementConstraints: "Requirement Constraints",
  applicabilityConditions: "Applicability Conditions",
  noConstraints: "This requirement has no constraints",
  noApplicabilityConditions: "This requirement has no applicability conditions",
  constraintType: "Constraint Type",
  constraintsLabel: "Constraints",
  subjectAreaLabel: "Subject Area",
  accreditorLabel: "Accreditor",
  audienceLabel: "Audience",
  logicalGroup: "Logical Group",
  conditionType: "Condition Type",
  operatorLabel: "Operator",
  referenceValue: "Reference Value",
  rangeEndValue: "Range End Value",

  // --- Accreditation: Requirement Authoring and the License Tracker (KONE-24754) ---
  authorAndPublishRequirements: "Author & Publish Requirements",
  requirementSet: "Requirement Set",
  cycleCreditCarryover: "Cycle · Credit · Carryover",
  trackerAvailability: "Tracker Availability",
  licenseTrackerAvailability: "License Tracker Availability",
  requirementsCount: "Requirements ({count})",
  addRequirement: "Add Requirement",
  newRequirementSet: "New Requirement Set",
  copyRequirementsFrom: "Copy Requirements From",
  startEmpty: "Start empty",
  create: "Create",
  review: "Review",
  openEnded: "(open)",
  notYetApproved: "Not yet approved",
  effectiveRange: "Effective {from} → {to}",
  approvedByOn: "Approved by {by} on {on}",
  trackableToday: "Trackable today: {value}",
  noRequirementsInSet: "No requirements in this set yet.",
  noRequirementSets: "No requirement sets",
  noTransitionsForRole: "No transitions available for this role.",
  noRequirementSetsForLicense:
    "This license has no requirement sets yet. Create one to start authoring its rules.",

  submitForReview: "Submit for Review",
  approve: "Approve",
  returnToDraft: "Return to Draft",
  archiveSet: "Archive Set",

  setGoverning: "Approved and governing — read-only.",
  setApprovedFuture: "Approved — governs from {from}.",
  setArchived: "Archived — this set no longer governs.",
  setSuperseded: "Approved — governed until {to}, superseded since.",
  setLockedForReview:
    "Locked for review — return the set to Draft to make changes.",

  setName: "Set Name",
  effectiveDate: "Effective Date",
  approvedBy: "Approved By",
  updateRequirementSet: "Update Requirement Set",
  leaveBlankForOpenEndedSet: "Leave blank for an open-ended set",
  requirementSetSaved: "The requirement set has been saved.",
  requirementSetUpdated: "The requirement set has been updated.",
  requirementSetCreated: "The requirement set has been created as a Draft.",
  requirementSaved: "The requirement has been saved.",
  cycleConfigurationIncomplete:
    "Choose a cycle type and a date scheme before saving the set.",
  endDateBeforeEffectiveDate: "The end date cannot be before the effective date.",

  cycleLengthMonths: "Cycle Length (months)",
  fixedMonth: "Fixed Month",
  fixedDay: "Fixed Day",
  oddEvenYear: "Odd / Even Year",
  gracePeriodDays: "Grace Period (days)",
  creditConfigurationSharedNotice:
    "Credit configuration belongs to the license and is shared by every one of its requirement sets, so it is edited with the license rather than here.",

  carryoverRules: "Carryover Rules",
  carryoverAllowedForSet: "Carryover allowed for this set",
  maxHours: "Max Hours",
  earnWindowMonths: "Earn Window (months)",
  maxPeriodsForward: "Max Periods Forward",
  appliesToSubjectAreaRequirements: "Applies to subject area requirements",

  addLicensureRequirement: "Add Licensure Requirement",
  editLicensureRequirement: "Edit Licensure Requirement",
  previousRequirement: "Previous requirement",
  nextRequirement: "Next requirement",
  moveUp: "Move up",
  moveDown: "Move down",
  locked: "Locked",
  deleteRequirement: "Delete requirement",
  deleteRequirementQuestion: "Delete requirement?",
  deleteRequirementWarning:
    '"{name}" will be removed from this requirement set. This cannot be undone.',

  addConstraint: "Add Constraint",
  addRequirementConstraint: "Add Requirement Constraint",
  editRequirementConstraint: "Edit Requirement Constraint",
  logicalGroupHelper: "Same group is OR, different groups are AND",
  deleteConstraintQuestion: "Delete constraint?",
  deleteConstraintWarning:
    "This constraint will be removed from the requirement. This cannot be undone.",

  addCondition: "Add Condition",
  addApplicabilityCondition: "Add Applicability Condition",
  editApplicabilityCondition: "Edit Applicability Condition",
  deleteApplicabilityConditionQuestion: "Delete applicability condition?",
  deleteApplicabilityConditionWarning:
    "This condition will be removed from the requirement. This cannot be undone.",

  brandOrganization: "Brand Organization",
  roadmapStatus: "Roadmap Status",
  setBy: "Set By",
  setRoadmapStatus: "Set roadmap status",
  released: "Released",
  comingSoon: "Coming Soon",
  notPlanned: "Not Planned",
  noAccess: "No access",
  organizationLicenseTracker: "{organization} — License Tracker",
  requirementsApproved: "Requirements approved — this license is governed.",
  noBrandOrganizations: "No brand organizations under the current header.",
  noApprovedRequirements:
    "No approved requirement set is governing this license yet.",
  requiresTrackerEnableClaim:
    "Requires the accreditation.license_tracker.enable claim",
  noOrganizationTracksLicense:
    "No organization under {organization} tracks this license",
  noOrganizationTracksThisLicense: "No organization tracks this license",

  // Requirement set lifecycle and notes (KONE-25807)
  lifecycle: "Lifecycle",
  archived: "Archived",
  noteType: "Note Type",
  addNote: "Add Note",
  editNote: "Edit Note",
  noNotes: "No notes",
  deleteNoteQuestion: "Delete note?",
  deleteNoteWarning: "The note \"{title}\" will be deleted.",
  regulatoryUrl: "Regulatory URL",
  boardInstruction: "Board instruction",
  userGuidance: "User guidance",
  internalNote: "Internal note",

  //Accreditation Bodies
  accreditationBodies: "Accreditation Bodies",
  approvalCode: "Approval Code",
  approvalDate: "Approval Date",
  skuAccreditationBodyFormTitle: "Qualification",
  skuAccreditationBodyCreateButtonLabel: "Add Qualification",
  skuAccreditationBodySaveButtonLabel: "Save Qualification",
  skuAccreditationBodyDeleteTitle: "Delete Qualification",
  skuAccreditationBodyDeleteQuestion:
    "Are you sure you want to delete this Qualification?",
  skuAccreditationBodyDeleteGroupQuestion:
    "This removes the Qualification and all {count} of its member entries. Continue?",
  skuAccreditationBodyDeleted: "The Qualification has been deleted.",
  skuAccreditationBodyUpdated: "The Qualification has been updated.",
  skuAccreditationBodyCreated: "New Qualification created!",
  skuAccreditationBodyFieldLockedTooltip:
    "This field was validated by {acronym} and cannot be changed.",
  selectAccreditationBodyFetchFailed:
    "Unable to fetch Accreditation Bodies list...",
  creditSubmissionExpirationDateCannotBeLessThanReleaseDate:
    "Credit Submission Expiration Date can't be less than Release Date",
  bulkSkuAccreditationBodyNewCountText:
    "{count} new accreditation body(ies) will be created.",
  bulkSkuAccreditationBodyExistingWarningText:
    "You are creating Accreditation Bodies that already exist for the Sku:",
  bulkSkuQualificationExistingItemFormat:
    "{qualification} / {profession} / {state}",
  bulkSkuQualificationOverridePromptText:
    "Do you want to Override the Existing values for them or keep the original existing values?",
  bulkSkuQualificationGenericConfirmationText:
    "Are you sure you want to proceed with this action?",
  internalValidationDialogTitle:
    "Course Number Mismatch within Product {productName}",
  internalValidationDialogMessage:
    "Other Skus for the same Product are using different course numbers. Course number being created: {courseNumber}",
  internalValidationDialogCourseNumbersInOtherSkus:
    "Course numbers in different Skus:",
  internalValidationDialogProceedQuestion: "Are you sure you want to proceed?",
  returnButton: "Return",
  createNewSkipExistingButton: "Create New, Don't Override Existing",
  overrideButton: "Override",
  fromDateLabel: "From",
  toDateLabel: "To",
  selectQualificationLabel: "Qualification",
  selectProfessionLabel: "Profession",
  selectStateLabel: "State",
  associatedSkus: "Associated SKUs",
  associatedSkusTitle: "Associated SKUs for {name}",
  backToAccreditationBody: "Back to accreditation body",

  //sku handouts
  courseHandouts: "Course Handouts",
  addHandout: "Add Handout",
  deleteHandoutFromSku: "Delete Handout from the Sku",
  areYouSureToDeleteHandout: "Are you sure you wish to delete this Handout?",
  handoutAdded: "The Handout has been added.",
  handoutUpdated: "The Handout has been updated.",
  handoutDeleted: "The Handout has been deleted.",
  errorLoadingHandout: "Error loading handout",
  backToCourseMaterialsLibrary: "Back to Course Materials Library",
  cantReorderWithProductLevelHandouts:
    "Can't reorder with the Course Handout inherited from the Product!",
  handoutInheritedFromProduct:
    "This Course Handout is inherited from the Product {productName} and can be managed on the Product page.",

  //certificates
  certificatesLabel: "Certificates",
  certificateNameLabel: "Name",
  certificateDescriptionLabel: "Description",
  certificateLoadError: "Error loading certificate",
  certificateThemeLabel: "Certificate Theme",
  certificateTemplateLabel: "Certificate Template",
  certificateTemplateCloneLabel: "Clone Certificate Template",
  certificateTemplateCloneComfirmationMessage:
    "Are you sure you want to clone this Certificate Template?",
  certificateDeleteTitle: "Delete Certificate",
  certificateDeleteInfo:
    "Are you sure that you wish to delete this certificate?",
  certificateFormNameLabel: "Name",
  certificateFormValueLabel: "Value",
  certificateFormDescriptionLabel: "Description",
  certificateFormEditTitle: "Edit - Certificate",
  certificateFormCreateTitle: "Create - Certificate",
  certificateFormCreateButton: "Create Certificate",
  certificateFormUpdateButton: "Update Certificate",
  detailsLabel: "Details",
  certificateUpdated: "Certificate updated sucessfully!",
  certificateCreated: "Certificate created sucessfully!",
  certificateSkuFormTitle: "Certificate SKUs",
  certificateProductsTitle: "Certificate Products",
  certificateSkuSkuLabel: "Sku",
  certificateSkuCreateButtonLabel: "Add Certificate Sku",
  certificateSkuDeleteTitle: "Delete Certificate Sku",
  certificateSkuDeleteQuestion:
    "Are you sure you wish to delete this Sku from the current certificate?",
  certificateSkuDeleted: "The certificate sku has been deleted.",
  certificateSkuDialogTitle: "Add Sku to Certificate",
  certificateSkuCreateMessage: "Certificate sku added successfully!",
  accordionDisabledToCreationMessage:
    "This option will enabled as soon as you create the entity",
  certificateProductDeleted: "The certificate product has been deleted.",
  certificateProductDeleteTitle: "Delete Certificate Sku",
  certificateProductProductLabel: "Product",
  certificateProductProductTypeLabel: "Product Type",
  certificateProductProductVersionLabel: "Product Version",
  certificateProductProductYearLabel: "Product Year",
  certificateProductCreateButtonLabel: "Add Certificate Product",
  certificateProductCreateMessage: "Certificate product added successfully!",
  certificateProductEmptyValuesMessage:
    "You have to select at least one option from the product based fields.",
  certificateProductDeleteQuestion:
    "Are you sure you want to remove these product filters from the current certificate?",

  // manual credit submission
  certificateIssuedStartDateLabel: "Certificate Issued Start Date",
  certificateIssuedEndDateLabel: "Certificate Issued End Date",
  exportOnlyNewEntriesLabel: "Export Only New Entries",
  exportOnlyNewEntriesInfoMessage:
    "If this option is selected all previous exported records won't be exported",
  exportResults: "Export Results",
  removeInternalUsersLabel: "Remove Internal Users",
  removeInternalUsersInfoMessage:
    "If checked, removes all emails in the setting from the list",
  approvingAuthorityTypeLabel: "Approving Authority Type",
  authority: "Authority",
  licenseNumber: "License Number",
  licenseState: "License State",
  nothingToExport: "Nothing to export",
  creditSubmissionExportWarning:
    "Do not update the exported file. This file should be uploaded directly to the Submission Authority. \n In case of bad data being produced, get in contact with Learning Tech.",
  firstName: "First Name",
  lastName: "Last Name",
  courseNumber: "Course Number",
  creditsAwarded: "Credits Awarded",
  completionDate: "Completion Date",
  reportExportError: "Error exporting report, try again later",
  exportDate: "Export Date",
  designationAuthority: "Designation Authority",
  download: "Download",
  upload: "Upload",
  uploadSubmissionStatus: "Upload Submission Status",
  resultsAreAlreadyUploaded:
    "The results file for this report has already been uploaded.",
  uploadSubmissionStatusFile: "Upload Submission Status File",
  uploadingSubmissionStatusFileCompleted:
    "Uploading Submission Status File successfully completed",
  previouslyExportedFiles: "Previously Exported Files",
  addCreditSubmissionReports: "Add Credit Submission Report",
  certStartDate: "Cert Start Date",
  certEndDate: "Cert End Date",
  submissionStartDate: "Submission Start Date",
  submissionEndDate: "Submission End Date",
  errorReportNotFound: "The report could not be found",
  errorDownloadingReport: "The report cannot be downloaded due to an error",
  middleName: "Middle Name",
  last4Ssn: "SSN (last 4)",
  email: "Email",
  dateOfBirth: "Date of Birth",
  courseTitle: "Course Title",
  providerLicenseNumberIssuedByDos: "Provider License Number Issued by DOS",
  providerName: "Provider Name",

  // certificate themes
  certificateThemeNameLabel: "Name",
  certificateThemeDescriptionLabel: "Description",
  certificateThemeApplicationLabel: "Application",
  certificateThemes: "Certificate Themes",
  certificateThemeFormCreateTitle: "Add - Certificate Theme",
  certificateThemeFormCreateButton: "Create Certificate Theme",
  certificateThemeFormFormUpdateButton: "Update Certificate Theme",
  certificateThemeFormNameLabel: "Name",
  certificateThemeFormValueLabel: "Value",
  certificateThemeFormDescriptionLabel: "Description",
  certificateThemeFormContentLabel: "Content",
  certificateThemeLoadError: "Error loading certificate theme",
  certificateThemeFormEditTitle: "Edit - Certificate Theme",
  certificateThemeDeleteTitle: "Delete Certificate Theme",
  certificateThemeDeleteInfo:
    "Are you sure that you wish to delete this certificate theme?",
  noCreditSubmissionReportsConfigured:
    "There are currently no Credit Submission Reports configured for this Organization.",

  // certificate templates
  certificateTemplateNameLabel: "Name",
  certificateTemplateDescriptionLabel: "Description",
  certificateTemplateDeleteTitle: "Delete Template",
  certificateTemplateDeleteInfo:
    "Are you sure you want to delete this template?",
  certificateTemplates: "Certificate Templates",
  certificateTemplateFormCreateTitle: "Add - Certificate Template",
  certificateTemplateFormCreateButton: "Create Certificate Template",
  certificateTemplateFormFormUpdateButton: "Update Certificate Template",
  certificateTemplateFormNameLabel: "Name",
  certificateTemplateFormValueLabel: "Value",
  certificateTemplateFormDescriptionLabel: "Description",
  certificateTemplateFormUnaccreditedLabel: "Unaccredited",
  certificateTemplateFormContentLabel: "Certificate Template Design",
  certificateTemplateLoadError: "Error loading certificate template",
  certificateTemplateFormEditTitle: "Edit - Certificate Template",
  certificateTemplateProfessionTemplateOverride:
    "Override Template Based on Profession",
  certificateTemplateAddProfession: "Add Override",
  certificateCompletionLabel: "Certificate of Completion",
  certificateTemplateSaveProfession: "Save Override",
  certificateTemplateProfessionsDialogTitleKey: "Add/Edit Override",
  certificateTemplateProfessionsOverrideLabel: "Template Override",
  certificateTemplatesOverrideDeleteTitle:
    "Delete Certificate Template Override",
  certificateTemplatesOverrideDeleteQuestion:
    "Are you sure you wish to delete this Certificate Template Override?",
  certificateTemplatesOverrideCreated:
    "Certificate Template Override saved successfully!",
  certificateTemplatesOverrideDeleted: "Certificate Template Override deleted!",
  certificateTemplateProfessionTemplateOverridenLabel: "Templates overriden",
  certificateTemplatesOverrideRepeated:
    "There is already a template for the selected profession",

  //Sku Learning Objectives
  skuFormLearningObjectiveTitle: "Learning Objectives",
  skuLearningObjectiveCreateButtonLabel: "Add Learning Objective",
  skuLearningObjectiveCreateButton: "Create Learning Objective",
  skuLearningObjectiveUpdateButton: "Update Learning Objective",
  skuLearningObjectiveDeleteQuestion:
    "Are you sure you wish to delete this Learning Objective?",
  skuLearningObjectiveDeleteTitle: "Delete Learning Objective",
  skuLearningObjectiveDeleted: "The Learning Objective has been deleted",
  learningObjectivePlaceholder: "Enter a Learning Objective description...",
  learningObjectiveEmptyProfessionMessage:
    "You can leave this field empty if don't want to set a value of profession",
  skuLearningObjectiveCreated: "Learning Objective created!",
  unspecifiedProfessionMessage:
    "In case you want to add a Profession, please do it by pressing the edit button",
  skuLearningObjectiveTitle: "Learning Objectives",

  // Qualifications
  qualificationType: "Qualification Type",
  studyFieldSubmitValidationRequired: "Is submit validation required?",
  qualificationStudyFieldAddTitle:
    "Add a Study Field to this Accreditation Body",
  qualificationStudyFieldAssociatedSuccess:
    "The Study Field was associated to this Accreditation Body",
  qualificationStudyFieldDeleteTitle:
    "Remove Study Field from this Accreditation Body",
  qualificationStudyFieldRemove:
    "Are you sure you want to remove the Study Field from this Accreditation Body?",
  qualificationStudyFieldRemovedSuccess: "The Study Field was removed",
  acronymLabel: "Acronym",
  accreditationBodyFormAddTitle: "Add Accreditation Body",
  accreditationBodyFormEditTitle: "Edit Accreditation Body",
  accreditationBodyFormDisplayValueLabel: "Display Value",
  displayOrderLabel: "Display Order",
  accreditationBodyFormSaveButton: "Save",
  accreditationBodyLoadError: "Error loading accreditation body",
  accreditationBodyCreated: "Accreditation body successfully created!",
  accreditationBodyUpdated: "Accreditation body successfully updated!",
  accreditationBodyDeleteTitle: "Delete Accreditation Body Override",
  accreditationBodyDeleted: "Accreditation body override deleted!",
  accreditationBodyDeleteQuestion:
    "Are you sure you want to delete this organization's qualification override? The accreditation body will revert to values inherited from the organization hierarchy.",
  accreditationBodyNotAccessible:
    "This organization doesn't have access to this accreditation body.",
  selectBaseAccreditationBodyLabel: "Select Existing Accreditation Body",
  accreditationBodyInherited:
    "Current values are inherited from the organization hierarchy. To manage this accreditation body, create an override using the Add button from the list.",
  qualificationStatementListLabel: "Qualification Statements",
  qualificationStudyFieldsListLabel: "Qualification Study Fields",
  qualificationStatementListTypeLabel: "Type",
  qualificationStatementListContentLabel: "Content",
  qualificationStatementFormAddTitle: "Add Qualification Statement",
  qualificationStatementFormEditTitle: "Edit Qualification Statement",
  qualificationStatementFormAddItemButton: "Add statement",
  qualificationAddStudyFieldButtonLabel: "Add Study Field",
  qualificationStudyFieldListStudyFieldNameLabel: "Study Field Name",
  qualificationStudyFieldSubmitValidationRequiredLabel:
    "Submit Validation Required",
  qualificationStatementFormSaveButton: "Save",
  qualificationStatementFormContentNameLabel: "Content",
  qualificationStatementFormTypeLabel: "Type",
  qualificationStatementCreated:
    "Qualification statement successfully created!",
  qualificationStatementDeleteTitle: "Delete qualification statement",
  qualificationStatementDeleteQuestion:
    "Are you sure you want to delete this qualification statement?",
  qualificationStatementDeleted: "Qualification statement deleted!",
  qualificationStatementTemplateNotAvailable: "Template not found",
  qualificationFormCreatedInCrmValueMessage:
    "This qualification was created in CRM and the value can't be edited in Admin Portal.",
  partialCreditIncrement: "Partial Credit Increment",
  minimumCredit: "Minimum Credit",
  cannotbeLessThanPartialCredits: "Can't be less than Partial Credit Increment",
  cantBeLessThanMinimumCredits: "Can't be less than Minimum Credit",
  creditIncrementLabel: "Increment Amount",
  minimumCreditMessage: "Minimum Credit (i.e. 1.25)",
  partialCreditIncrementMessage: "Partial Credit Increment (i.e. 0.25)",
  qualificationApprovals: "Qualification Approvals",
  addApproval: "Add approval",
  approvalCreated: "Approval created",
  approvalSaved: "Approval saved",
  areYouSureToDeleteQualificationApproval:
    "Are you sure you want to delete this qualification approval?",
  deleteQualificationApproval: "Delete Qualification Approval",
  addQualificationApproval: "Add Qualification Approval",
  editQualificationApproval: "Edit Qualification Approval",
  approvalDeleted: "Approval deleted!",
  qualificationApprovalInheritedTooltip:
    "You need to be at {organizationName} to edit those fields.",
  cannotBeLessThan025: "Can't be less than 0.25",

  /* Webinars */
  appInstanceLabel: "Instance",
  appInstanceClientLabel: "Client",
  startDateTimeLabel: "Start Date/Time",
  endDateTimeLabel: "End Date/Time",
  webinarsListLabel: "Webinars Edit",
  webinar: "Webinar",
  popUpsAnswered: "Pop ups Answered",
  popUpsAsked: "Pop ups Asked",
  presence: "Presence %",
  timeInSession: "Time in Session",
  exitTime: "Exit Time",
  entryTime: "Entry Time",
  resultsOfAttendanceProcess: "Results of Attendance Process",
  attendanceSearchPlaceholder: "Search by Name or Email",
  viewResults: "View Results",
  resultsType: "Results Type",
  registrations: "Registrations",

  /*Templates */
  templatesLabel: "Templates",
  templateTypeLabel: "Template Type",
  templateDesignLabel: "Template Design",
  templateDesignDraftLabel: "Draft Template Design",
  templateFormEditTitle: "Edit - Template",
  templateFormCreateTitle: "Add - Template",
  templateLoadError: "Error loading the Template",
  deleteTemplateTitle: "Delete Template",
  deleteTemplateInfo: "Are you sure that you want to delete this template?",
  notDraftDisabledMessage:
    "This option will enabled as soon as you create a draft version",
  placeholderNameDisabledForPageMessage:
    "The Placeholder Name is not availabe for the type Page",
  codeConstantDisabledForNotPageMessage:
    "The Code Constant is availabe only for the type Page",
  dirtyPreviewDisabledMessage:
    "This option will enabled as soon as you save your changes",
  contentLabel: "Content",
  contentDraftLabel: "Content - Status: Draft",
  contentPublishedLabel: "Content - Status: Published",
  entityLabel: "Entity",
  placeholderNameLabel: "Placeholder Name",
  saveDraftButton: "Save Draft",
  discardDraftButton: "Discard Draft",
  publishVersionButton: "Publish Version",
  previewButton: "Preview",
  templatePreviewTitle: "Template Preview",
  PreviewDataSelectorDialogTitle: "Data required for the preview",
  thisTemplateCannotBeEdited:
    "This template cannot be edited for {organizationName}, because it is associated with a different Organization in the hierarchy and changes to the template could negatively impact other Organizations. If you want to edit the template specifically for {organizationName}, please create a copy and associate it to {organizationName}.",

  /*Menus */
  menusLabel: "Menus",
  menuTypeLabel: "Menu Type",
  backToDynamicMenu: "Back to options",
  menuLoadError: "Error loading menu...",
  menuFormNameLabel: "Name",
  menuFormDescriptionLabel: "Description",
  menuFormRequireSequentialCompletionLabel: "Require Sequential Completion",
  menuDeleteTitle: "Delete Menu",
  menuDeleteInfo: "Are you sure that you wish to delete this menu?",
  menuFormMenuTypeLabel: "Menu Type",
  menuFormEditTitle: "Edit - Menu",
  menuFormCreateTitle: "Add - Menu",
  menuFormEditButton: "Update Menu Information",
  menuFormCreateButton: "Save Menu Information",

  /*Organization Dynamic Menus (KONE-24619) */
  dynamicMenus: "Dynamic Menus",
  dynamicMenuIsInherited:
    "This dynamic menu is inherited from {organizationName} and can be managed on that Organization page.",
  assignDynamicMenu: "Assign Dynamic Menu",
  assign: "Assign",
  menu: "Menu",
  menuName: "Menu Name",
  viewMenu: "View Menu",
  unassignMenu: "Remove Assignment",
  unassignDynamicMenuTitle: "Remove Menu Assignment",
  unassignDynamicMenuInfo:
    "Are you sure that you wish to remove this dynamic menu from the organization?",
  dynamicMenuAssignSuccess: "Dynamic menu assigned successfully.",
  menuAlreadyAssignedForType:
    "This organization already has a menu of that type assigned.",
  menuCannotBeDeletedInUse:
    "This menu is assigned to one or more organizations and cannot be deleted. Remove the assignments first.",
  menuInUseWarning:
    "This menu is in use by {count, plural, one {# organization} other {# organizations}}. Changes will affect all of them.",
  menuTypeCannotBeChanged:
    "The menu type cannot be changed after a menu has been created.",

  /*Menu Items */
  menuItemsLabel: "Menu Items",
  menuItemLabel: "Menu Item",
  menuItemDeleteTitle: "Delete Menu Item",
  menuItemDeleteInfo: "Are you sure that you wish to delete this menu item?",
  menuItemFormCreateTitle: "Add - Menu Item",
  menuItemFormEditTitle: "Edit - Menu Item",
  menuItemFormCreateButton: "Create Menu Item",
  menuItemLoadError: "There was an error loading the menu item...",
  menuItemFormEditButton: "Update Menu Item",

  /*Menu Structures */
  menuStructuresLabel: "Menu Structures",
  bodyTagErrorMessage:
    "The theme content should contain the keyword [[BODY]] to wrap the template. Please add this keyword in order to save it.",
  menuStructureTypeLabel: "Menu Structure Type",

  /*Menu Items */
  toolTipLabel: "ToolTip",
  urlLabel: "URL",
  claimLabel: "Claim",
  iconLabel: "Icon",

  searchIconsPlaceholder: "Search Icons...",
  selectFetchFailed: "Unable to fetch the requested list.",
  parentMenuStructureLabel: "Parent Menu Structure",
  menuStructureCreateButtonLabel: "{prefix} Menu Structure",
  menuStructureDeleteTitle: "Delete Menu Structure",
  menuStructureDeleteQuestion:
    "Are you sure that you wish to delete this menu structure?",
  menuStructureDeleted: "Menu structure deleted!",
  goToMenuItemsLabel: "Go To Menu Items",
  goToMenusLabel: "Go To Menus",
  menuStructureCreateMessage: "Menu Structure created!",
  sequenceLabel: "Sequence",
  toChangeParentEditMenuStructure:
    "To change the Parent please edit the Menu Structure",

  htmlWarningMessage:
    "In order to add HTML code, please press the '<>' button located at the right of the toolbar.",

  importsStep1Label: "Imports Step 1: Upload File",
  importsStep2Label: "Imports Step 2: File Details",
  importsStep3Label: "Imports Step 3: File Processing",
  notSplitYetLabel: "Not split yet",
  cancelledLabel: "Cancelled",
  calculatingLabel: "Calculating…",
  importRunningLabel: "{progress}% — processing, please wait…",
  importFinishedLabel: "{progress}% — process finished",
  totalLabel: "Total",
  processedLabel: "Processed",
  erroredLabel: "Errored",
  inProgressLabel: "In progress",
  importsStepUploadLabel: "Upload file",
  importsStepMapLabel: "Map columns",
  importsStepProcessLabel: "Process",
  importedEntitiesLabel: "Imported Entities",
  generatedIdLabel: "Generated Id",
  resultsLabel: "Results",
  sharedAcrossImportLabel: "Shared across this import",
  sharedBySkusLabel: "{count, plural, one {# sku} other {# skus}}",
  quickFilterAllLabel: "All",
  quickFilterSucceededLabel: "Succeeded",
  quickFilterHasErrorsLabel: "Has errors",
  quickFilterProcessingLabel: "Processing",
  entitiesTruncatedMessage:
    "This import is too large to show as a tree. Showing the record list instead.",
  entitiesUnavailableMessage:
    "The entity breakdown could not be loaded. Showing the record list instead.",
  noEntitiesMessage: "This job has not been split into entities yet.",
  selectLabel: "Select",
  emptyColumnsExcelMessage:
    "The CSV provided doesn't contains any column or could not be processed. Please remove the file and retry.",
  notYetEvaluatedMessage: "Not yet evaluated/Ignored",
  validationCheckFailedMessage:
    "The first {rows} of column No. {column} could not be converted to the target type.",
  validationEmptyColumnMessage:
    "The column is properly mapped, but some of the values are blank. Please check if this is valid for the given field.",
  validationCheckSuccessfullMessage:
    "Column No. {column} was successfully converted to the target type.",
  relatesToLabel: "relates to",
  notAllColumnsRequiredAreValidMessage:
    "There are required columns which couldn't be parsed to the required type. Please review the ones that are highlighted.",
  dataImportContentError: "The was an error processing the given file",
  importsProcessFileTitle: "Process Data Import",
  importsProcessFileQuestion:
    "Are you sure you want to process the file with the given configuration?",
  importsUploadSuccess: "Data successfully queued for migration!",
  importsUploadSuccessMessage:
    "You have successfully submitted your file for import.",
  importsUploadAbortedMessage:
    "The process has been aborted. You can safely abandon this page or restart the process.",
  importsUploadSuccessNote:
    "Please note, the import process will run in the background - The summary will appear below shortly.",
  emptyValueColumnMessage:
    "Some column of your file has empty data. Please, remove that column to continue to the mapping page.",
  goToFileDetails: "Go To File Details",
  mappingLabel: "Mapping",
  fileColumnNameLabel: "File Column Name",
  successAssignmentMessageLabel:
    "The assignment was successful. You can process the file!",
  pendingAssignmentLabel: "Pending Assignment",
  pendingAssignmentMessageLabel:
    "There are required fields that has not been properly assigned in the current import. Pending assignments: ",
  migrationTypeLabel: "Migration Type",
  anyColumnMatchTitle: "Columns not matching",
  anyColumnMatchErrorMessageLabel:
    "Any of the columns defined on this migration match with the ones on the file provided. ",
  notColumnsHasBeenDefinedInTheImport:
    "The import specified doesn't have any columns defined. Please notify technical team.",

  partnerLabel: "Partner",
  partnerIdLabel: "Partner ID",
  dateTimeLabel: "Date/Time",
  requestsLabel: "KLG API Requests Details",
  requestsValidationSearch:
    "To search by text, it is necessary to enter a period of less than 7 days.",
  request: "Request",
  response: "Response",
  reprocessButton: "Reprocess",
  reprocessRequestMessage: "Do you want to reprocess all selected orders?",
  reprocessFinished: "Reprocess finished",

  previewLabel: "Preview",
  previewNotAvailableLabel: "Preview is not available",
  previewEvaluationLabel: "Preview evaluation",
  previewTemplatesAndOverridesLabel: "Preview Templates & Overrides",
  templateEmptyMessage:
    "The template is empty. Please add some content in order to display it.",
  overrideNameLabel: "Override: {profession}",
  addConfidenceLevelsLabel: "Add Confidence Levels",
  questionConfidenceLevelsAdviceMessage:
    "In order to show the confidence levels on the questions of this evaluation, you should check the 'Add Confidence Levels' option on the questions that you want to be displayed",
  evaluationConfidenceLevelsAdviceMessage:
    "In order to show the confidence levels on this question, you should check the 'Add Confidence Levels' option on the evaluation as well",
  userCertificateLabel: "User Certificate",
  regenerateLabel: "Regenerate",
  certificateDateLabel: "Certificate Date",
  issueDateLabel: "Issue Date",
  invalidTokenMessage: "Invalid token. This page can't be accessed",
  sourceLabel: "Source",
  jobTypeLabel: "Job Type",
  jobStatusLabel: "Job Status",

  editDeliveryMethodKeyLabel: "Edit Content Delivery Key",
  processAttendanceLabel: "Process Attendance",
  markAllUsersAsAttended: "Mark All Users as Attended",
  attendanceProcessingForAllUsersHasStarted:
    "Attendance processing for all users has started",
  notDeliveryMethodMessage:
    "This webinar doesn't have a content delivery configured. Please check in Skus page to add one",
  processAttendanceConfirmationMessage:
    "Do you want to start processing the attendance of this webinar?",
  attendanceProcessedMessage:
    "The attendance has been properly processed for Webinar: {webinar} - Organization: {organization}",

  //Settings
  settings: "Settings",
  settingNameLabel: "Setting Name",
  settingInheritedFromLabel: "Inherited From",
  settingInheritanceLabel: "Inheritance",
  settingInheritanceAll: "All",
  settingInheritanceOverridden: "Overridden",
  settingInheritanceInherited: "Inherited",
  deleteSettingValueButton: "Delete Value for this Organization",
  settingValueSaved: "Setting Value Saved!",
  settingValueDeleted: "Setting Value Deleted!",
  settingValueInheritedFromLabel: "Value Inherited from",
  noChangesLabel: "No change has been made",
  invalidColor: "Invalid color",
  jsonOnlyObjectsAllowed: "Only objects are allowed, arrays are not permitted",
  jsonMustBeValidObject: "Value must be a valid JSON object",
  invalidJsonFormat: "Invalid JSON format",
  formatJsonButton: "Format JSON",
  settingValueLabel: "Setting Value",
  settingLoadError: "Error retrieving settings",
  settingSaveConfirmationText:
    "Confirm adding/editing value for the {organization} organization?",
  settingDeleteConfirmationText:
    "Confirm deleting value for the {organization} organization?",

  // Reprocess Completions
  reprocessCompletions: "Reprocess Completions",
  userDeliverableCompletionIdsLabel: "User Deliverable Completion IDs",
  reprocessCompletionsSuccess: "Successfully processed {count} completion(s)",
  sendEmailsLabel: "Send Emails",

  // Wizard
  wizards: "Wizards",
  wizardFormCreateButton: "Create Wizard",
  wizardFormUpdateButton: "Update Wizard",
  wizardFormCreateTitle: "New Wizard",
  inflectionPointLabel: "Inflection Point",
  isActiveLabel: "Is Active",
  headerTextLabel: "Header Text",
  footerTextLabel: "Footer Text",
  wizardDeleteLabel: "Delete Wizard",
  wizardDeleteInfo: "Are you sure you want to delete this wizard?",
  wizardLoadError: "Error retrieving wizard",
  widgetsLabel: "Widgets",
  widgetNameLabel: "Widget name",
  optionalLabel: "Optional",
  noWidgetsFound: "No widgets found",
  addWidgetButton: "Add widget",
  widgetCannotBeAddedTwice: "Widget cannot be added more than once",

  // Organizations
  organizations: "Organizations",
  syncOrganizations: "Sync Organizations",
  syncOrganizationsWarning: "Do you want to sync the Organizations?",
  organizationNameLabel: "Organization Name",
  displayNameLabel: "Display Value",
  accountIdLabel: "Account Id",
  organizationTypeLabel: "Organization Type",
  organizationStatusLabel: "Organization Status",
  organization: "Organization",
  ownerOrganization: "Owner Organization",
  administrators: "Administrators",
  adminIsInherited:
    "This Organization Admin is inherited from {organizationName} and can be managed on that Organization page.",
  inheritedFrom: "Inherited From",
  viewUser: "View User",
  partners: "Partners",
  contracts: "Contracts",
  childOrganizations: "Child Organizations",
  childOrganization: "Child Organization",
  applicationOverrides: "Application Overrides",
  addApplicationOverride: "Add Application Override",
  editApplicationOverride: "Edit Application Override",
  deleteApplicationOverride: "Delete Application Override",
  deleteApplicationOverrideConfirmation:
    "Are you sure you want to delete the override for {application}?",
  noApplicationOverridesConfigured: "No application overrides configured.",
  applicationOverridesLoadError: "Failed to load application overrides.",
  addAdministrator: "Add administrator",
  deleteAdministrator: "Delete administrator",
  deleteAdministratorConfirmation:
    "Are you sure you want to remove this Admin from this Organization? They will immediately lose access.",
  addPartner: "Add partner",
  administratorSaveSuccess: "Administrator has been successfully saved",
  partnerSaveSuccess: "Partner has been successfully saved",
  organizationFormCreateTitle: "New Organization",
  organizationCreateButton: "Create Organization",
  organizationFormUpdateButton: "Update Organization",
  parentOrganizationHeaderTooltip: "Inherited from the organization filters.",
  parentOrganizationBodyTooltip:
    "To update the parent organization, update the organization selected in the Kadmin header filters",
  rootOrganizationIsNotAllowedTooltip:
    "The root Organization is not allowed, please change the Organization in the header.",
  addOrgAdminConfirmationText:
    "The user {email} will be added as an administrator of the current organization, do you want to proceed?",
  adminAlreadyInThisOrganization:
    "The user {email} is already an Admin in this Organization.",
  adminInheritedFromOrganization:
    "The user {email} is already an Admin in this Organization, as they are inherited from {organizationName}.",
  adminExistsInDescendantOrganizations:
    "The user {email} is already an Admin in {organizationNames}. Are you sure you want to add them at this higher level? Their Organization Portal access in {organizationNames} will be deactivated.",
  accessLevels: "Access levels",
  skuTitleColumnLabel: "SKU Title",
  addAccessLevelButton: "Add access level",
  updateAccessLevelButton: "Update access level",
  deleteAccessLevelTitle: "Delete access level",
  deleteAccessLevelQuestion:
    "Are you sure that you want to delete this access level?",
  environmentLabel: "Environment",
  isDefaultLabel: "Is Default",
  applicationDomains: "Application domains",
  addApplicationDomain: "Add application domain",
  updateApplicationDomain: "Update application domain",
  applicationDomainSaved: "Application domain has been saved",
  applicationDomainDeleteQuestion:
    "Are you sure you wish to delete this application domain?",
  applicationDomainDeleteTitle: "Delete application domain",
  applicationDomainDeleted: "Application domain has been deleted",
  externalReferences: "External references",
  addExternalReference: "Add external reference",
  updateExternalReference: "Update external reference",
  partnerNameLabel: "Partner name",
  externalOrganizationIdLabel: "External organization ID",
  externalReferenceSaved: "External reference has been saved",
  externalReferenceDeleted: "External reference has been deleted",
  externalReferenceUpdateTitle: "Update external reference",
  externalReferenceUpdateQuestion:
    "This changes the link between this organization and {partnerName}. Do you want to continue?",
  externalReferenceUpdateRusticiQuestion:
    "This changes this organization's Content Controller account. Learners on the current account ({externalOrganizationId}) will immediately lose access to SCORM courses. Do you want to continue?",
  externalReferenceDeleteTitle: "Delete external reference",
  externalReferenceDeleteQuestion:
    "This removes the link between this organization and {partnerName} ({externalOrganizationId}). Do you want to continue?",
  externalReferenceDeleteRusticiQuestion:
    "This removes this organization's Content Controller account ({externalOrganizationId}). Learners on that account will immediately lose access to SCORM courses. Do you want to continue?",
  creatableSelectOther: "Other",
  creatableSelectNewOptionHelp:
    "Confirm or cancel the new option before continuing.",
  creatableSelectConfirmNewOption: "Confirm new option",
  creatableSelectCancelNewOption: "Cancel new option",
  catalogSkus: "Catalog SKU",
  addOrganizationCatalogSkuButton: "Add Catalog Sku",
  updateOrganizationCatalogSkuButton: "Update Catalog Sku",
  deleteOrganizationCatalogSkuTitle: "Delete Catalog Sku",
  deleteOrganizationCatalogSkuQuestion:
    "Are you sure you wish to delete this catalog sku from the organization?",
  deactivateOrganizationTitle: "Deactivate Organization",
  deactivateOrganizationQuestion:
    "Are you sure you want to deactivate this Organization? This will automatically remove all Organization Admin users from the Organization, and will expire all Learner's access to the Catalog. All users will retain read-only access to their certificates. This action can not be reversed.",
  organizationCatalogInheritedTooltip:
    "This Catalog is inherited from {organizationName}. Adding a Catalog to this Organization will override this.",
  addContract: "Add Contract",
  contractType: "Contract Type",
  renewalDate: "Renewal Date",
  addContractButton: "Add Contract",
  updateContractButton: "Update Contract",
  deleteContractTitle: "Delete Contract",
  deleteContractQuestion: "Are you sure that you want to delete this Contract?",
  contractActionTitle: "Contract has been {action}",

  // Media library
  mediaLibrary: "Media Library",
  backToMediaLibraryLabel: "Back to Media Library",
  backToMediaLibraryItemLabel: "Back to Media Library Item",
  mediaLibraryItemFormCreateTitle: "New Media",
  mediaLibraryItemFormUpdateTitle: "Update Media",
  mediaLibraryItemUpdated: "Media library item successfully updated!",
  alternativeTextLabel: "Alternative Text",
  mediaPerPage: "Media per page",
  fileFormatLabel: "File format",
  uploadedOn: "Uploaded on: {uploadedOn}",
  uploadedBy: "Uploaded by: {uploadedBy}",
  fileNotFound: "File not found",
  uploadingFileError: "There was an error uploading your file",

  // Notifications
  notifications: "Notifications",
  notificationConfigurations: "Notifications",
  notificationConfigurationDetails: "Notification Details",
  notificationConfigurationInheritedTooltip:
    "You need to be at {organizationName} to edit this notification configuration.",
  notificationConfigurationDeleteTitle: "Delete Notification Configuration",
  notificationConfigurationDeleteQuestion:
    "Are you sure you want to delete this notification configuration?",
  createNotificationConfiguration: "Create Notification",
  editNotificationConfiguration: "Edit Notification",
  updateNotificationConfiguration: "Update Notification",
  trigger: "Trigger",
  eventKey: "Event Key",
  condition: "Condition",
  channel: "Channel",
  titleSubject: "Title / Subject",
  displayMode: "Display Mode",
  actionUrl: "Action URL",
  actionLabel: "Action Label",
  frequency: "Frequency",
  frequencyInterval: "Every",
  repeatEvery: "Repeat every…",
  intervalType: "Unit",
  dismissal: "Dismissal",
  validFrom: "Valid From",
  expiresOn: "Expires On",
  sent: "Sent",
  draft: "Draft",
  notificationBody: "Body",
  livePreview: "Live Preview",

  emailTemplates: "Email templates",
  emailThemes: "Email themes",
  emailTheme: "Email Theme",
  emailThemeTitle: "Email Theme for {organizationName}",
  backToNotifications: "Back to Notifications",
  preview: "Preview",
  noEmailTheme:
    "There is no Email Theme configured for this Organization. Click the + icon to create one.",
  deleteEmailThemeConfirmation:
    "Confirm deleting value for the {organizationName} organization?",
  addEmailTheme: "Add - Email Theme",
  addEmailThemeTitle: "Add Email Theme for {organizationName}",
  editEmailTheme: "Edit - Email Theme",
  editEmailThemeTitle: "Edit Email Theme for {organizationName}",
  createEmailTheme: "Create Email Theme",
  updateEmailTheme: "Update Email Theme",
  cloneEmailTemplate: "Clone Template",
  cloneEmailTemplateConfirmationMessage:
    "Are you sure you want to clone this Email Template?",
  subject: "Subject",
  addEmailTemplate: "Add - Email Template",
  editEmailTemplate: "Edit - Email Template",
  createEmailTemplate: "Create Email Template",
  updateEmailTemplate: "Update Email Template",
  templateName: "Template Name",
  senderName: "Sender Name",
  senderEmail: "Sender Email",
  ccEmails: "CC Emails",
  bccEmails: "BCC Emails",
  deleteEmailTemplateConfirmation:
    "Confirm deleting Email Template {emailTemplateName}?",

  // Course Registrations
  courseRegistrations: "Course Registrations",
  courseRegistrationsTitle: "Course Registrations for {sku}",
  exportRegistrations: "Export Registrations",
  downloadRegistrations: "Download Registrations",
  moveSkuRegistrations: "Move Registrations",
  moveSkuRegistrationsInfo:
    "Only Active or In-Progress users will be registered to the new Sku.",
  targetSkuLabel: "Target Sku",
  expireSourceSkuRegistrations:
    "Do you also want to expire access for the source Sku?",
  downloadAttendanceRecords: "Download Attendance Records",
  exportProcessing: "Export Processing",
  exportProcessingMessage:
    "Your exporting is currently being processed. Shortly, you'll be sent an email with a link to the file when it is ready!",

  // Tools
  userSkuTitle: "UserSku for {name}",
  tools: "Tools",
  registrationManagement: "Registration Management",
  enrollmentManagement: "Enrollment Management",
  userManagement: "User Management",
  profileManagement: "Profile Management",
  profileManagementTitle: "Manage Profile Information for {email}",
  addCredential: "Add Credential",
  editCredential: "Edit Credential",
  deleteCredentialTitle: "Delete Credential",
  confirmDeleteCredential:
    "Are you sure you want to delete the credential for {designation}?",
  credentialSaved: "Credential saved successfully",
  credentialDeleted: "Credential deleted successfully",
  designation: "Designation",
  profession: "Profession",
  location: "Location",
  licensureBody: "Licensure Body",
  license: "License",
  national: "National",
  selectDesignation: "Select Designation",
  selectLocation: "Select Location",
  selectLicensureBody: "Select Licensure Body",
  designationOnly: "Save designation only (without license)",
  professionalInformation: "Professional Information",
  professionalInfoSaved: "Professional information saved successfully",
  credentialDetails: "Credential Details",
  preEvaluation: "Pre-Evaluation",
  exam: "Exam",
  postEvaluation: "Post-Evaluation",
  certificates: "Certificates",
  submissions: "Submissions",
  certificate: "Certificate",
  creditSubmission: "Credit Submission",
  userCreditSubmissions: "{name} Credit Submissions",
  participationDate: "Participation Date",
  submissionDate: "Submission Date",
  viewModifyCerts: "View / Modify Certificates",
  viewModifySubmissions: "View / Modify Submissions",
  viewModifyRegistration: "View / Modify Registration",
  viewModifyRegistrationTitle: "View / Modify Registration for {name}",
  processChargeBackLabel: "Process Chargeback",
  processChargeBackTitle: "Process Chargeback for {name}",
  changeParentUserSku: "Change Parent",
  changeParentUserSkuTitle: "Change Parent for {name}",
  currentParentUserSkuLabel: "Current Parent SKU",
  currentParentUserSkuTitleLabel: "Current Parent SKU Title",
  newParentUserSkuLabel: "New Parent SKU",
  updateParentUserSkuLabel: "Update Parent SKU",
  changeParentUserSkuSuccessLabel: "Parent SKU successfully updated.",
  renewalDateLabel: "Order/Renewal Date",
  childSkusAffectedLabel: "Child Skus affected",
  chargeBackUserSkuConfirmation:
    "Processing a chargeback will remove this users access to certificates as well as revoke credits at external submission authorities. Please proceed with caution.",
  isCertificationDisabledTooltip:
    "An Expired or Completed UserSku can't be updated. If required, please add a new one.",
  isModifyRegistrationDisabledTooltip:
    "A Completed UserSku can't be updated. If required, please add a new one.",
  userCertificatesLabel: "{name} Certificates",
  regenerateCertificatesWarning:
    "By clicking Regenerate Certificates below, all certificates earned in MyPortal by this learner will be regenerated, even if they do not appear on this page. Certificates imported from legacy platforms will not be updated.",
  reprocessSubmissionsPreWarning:
    "Before proceeding, please regenerate certificates.",
  reprocessSubmissionsWarning:
    "By clicking Reprocess Submissions below, we will attempt to resubmit all failed submissions to their submission authorities, even if it is outside of the allowed submission window. Submissions imported from legacy platforms will not be resubmitted.",
  regenerateCertificatesConfirmationMessage:
    "Are you sure you want to proceed? This action cannot be undone.",
  regenerateCertificatesLabel: "Regenerate Certificates",
  reprocessSubmissionsLabel: "Reprocess Submissions",
  certificatesAreRegenerating: "Certificates are being regenerated",
  reprocessSubmissionsInProgress: "Submissions are being reprocessed",
  regenerationInProgressText:
    "Previously generated certificates are being removed and the new ones are being generated",
  reprocessSubmissionsInProgressText:
    "Previous submissions are being reprocessed and the new ones are being generated",
  certificatesRegenerated: "Certificates have been regenerated",
  submissionsReprocessed: "Submissions have been reprocessed",
  regenerationSuccessText:
    "Previously generated certificates have been removed and the customer may now view their updated certificates",
  reprocessSubmissionsSuccessText:
    "Submissions have been reprocessed successfully.",
  tryAgainLater: "Try again later",
  registrationDetails: "Registration Details",
  courseName: "Course Name",
  userId: "User ID",
  userSkuId: "UserSKU ID",
  saveChangesLabel: "Save changes",
  liveEvent: "Live event",
  examResults: "Exam results",
  newTestWebinar: "New Test Webinar",
  webinarCreatedLabel: "Webinar successfully created",
  userDesignationsChangeLog: "User Designations Change Log",
  viewUserDesignationsChangeLog: "View Change Log",
  userDesignationsChangeLogTitle: "{name} Profile Changes Log",
  previousValueLabel: "Previous Value",
  changeLabel: "Change",
  timeStampLabel: "Change Date",
  profileChangesLog: "Profile Changes Log",
  changedByLabel: "Changed By",

  // Processes
  processesListLabel: "Synchronization Processes",
  processTitle: "Process",
  actionTitle: "Action",

  sentEmails: "Sent Emails",
  sentEmailTitle: "Sent Email for {name}",
  emails: "Emails",
  viewEmail: "View Email",
  resendEmail: "Resend Email",
  sentLabel: "Sent",
  provider: "Provider",
  emailProviderLabel: "Sent through {provider}",
  senderLabel: "Sender",
  recipientLabel: "Recipient",
  templateLabel: "Template",
  emailResendSuccess: "Email successfully resent.",
  emailResendFailure: "Failed to resend email.",
  emailsValidationSearch:
    "To search by text or sort, it is necessary to enter a period of less than 7 days.",

  // Agreements
  newAgreement: "New Agreement",
  editAgreement: "Edit Agreement",
  agreementDetailsTitle: "Details",
  agreementUserInputTitle: "User Inputs",
  agreementContentTitle: "Content",
  jsonUserInputLabel: "Json User Inputs",
  agreementDisplayNameLabel: "Display Name",
  agreementCreated: "Agreement Created sucessfully!",
  agreementUpdated: "Agreement Updated sucessfully!",
  agreementContentSaved: "Agreement Content saved sucessfully!",
  copyTemplate: "Copy Template",

  // SKU Cover Image
  skuCoverImageLabel: "Cover Image",
  addCoverImageLabel: "Add Cover Image",

  // User sync
  syncUser: "Sync User",
  syncUsers: "Sync Users",
  syncUsersConfirmation: "Are you sure you want to sync the selected users?",
  syncUserConfirmation: "Are you sure you want to sync this user?",
  userSyncSuccess: "Users synced successfully",
  userSyncError: "Error syncing users",

  // User deletion
  deleteUsersTitle: "Delete Users",
  deleteUsersConfirmation:
    "Are you sure you want to delete the selected users?",
  userDeleteError: "Error deleting users",

  // Webhooks
  webhooksLabel: "Webhooks",

  // Data Tools
  dataTools: "Data Tools",
  scriptRunner: "Script Runner",
  sqlScript: "SQL script",
  targetDatabase: "Target database",
  scriptRunnerWarning:
    "Scripts run against the selected database immediately and cannot be rolled back. Every run is recorded in the Logging service before it executes.",
  wrapInTransaction: "Wrap in a transaction",
  noTransactionHint:
    "Without a transaction the script commits as it goes. Use this for batched scripts, where one transaction over the whole batch would escalate locks — but a failure partway through will leave earlier statements applied.",
  scriptRunnerRunUnknown:
    "The request failed before a result came back. The script may already be queued — check the run history below before submitting again.",
  scriptRunnerHistoryHint:
    "Script runs appear in Data Tools alongside every other tool run, with their progress log and result.",
  scriptRunnerRunRefused:
    "The run was not recorded in the Logging service, so the script was not executed.",
  run: "Run",
  inputOptional: "Input (optional)",
  logs: "Logs",
  runHistory: "Run History",
  selectATool: "Select a tool...",
  tool: "Tool",
  started: "Started",
  by: "By",
  completed: "Completed",
  startedAtBy: "Started: {date} by {name}",
  completedAt: "Completed: {date}",
  dataToolsInputValue: "Input: {value}",
  waitingForOutput: "Waiting for output...",
  noOutput: "No output.",
  downloadFullLogButton: "Download full log",
  showingLastLogsHint:
    "Showing last {count} lines of {total} — download for full output.",
  notificationIdLabel: "Notification ID",
  deliveryStatusLabel: "Delivery Status",
  eventTypeLabel: "Event Type",
  transactionIdLabel: "Transaction ID",
  invoiceNumberLabel: "Invoice Number",
  amountLabel: "Amount",
  subscriptionIdLabel: "Subscription ID",
  hasSubscriptionIdLabel: "Has Subscription ID",
  searchBySubscriptionId: "Search by Subscription ID",
  resendLabel: "Re-send",
  resendButton: "Re-send",
  resendConfirmation:
    "Are you sure you want to re-send the selected notifications?",
  resendSuccess: "Successfully re-sent {count} notification(s)",
  resendPartialFailure:
    "Re-sent {successCount} notification(s), {failureCount} failed",

  healthCheckLabel: "Health Check",
  healthCheckPageTitle: "Microservices Health Status",
  healthCheckServiceLabel: "Service",
  healthCheckUrlLabel: "URL",
  healthCheckStatusLabel: "Status",
  healthCheckStatusHealthy: "Healthy",
  healthCheckStatusDegraded: "Degraded",
  healthCheckStatusUnhealthy: "Unhealthy",
  healthCheckStatusFailure: "Failure",
  healthCheckNoServicesMessage: "No microservices configured.",
  healthCheckUrlTooltip: "Click to view health details in new tab",
  healthCheckAzureDashboard: "Azure Performance Dashboard",

  // --- ACPE Validation Dialog ---
  nabp: "NABP",
  currentSkuQualification: "Current Sku Qualification",
  creditExpirationDate: "Credit Expiration Date",
  nabpValidationError: "NABP validation error",
  validatingCourseInformationWithNabp:
    "Validating Course Information with NABP",
  courseNumberBeingValidated:
    "Course number {courseNumber} is being validated. Please, wait a few moments.",
  nabpMismatchWarning:
    "There is a mismatch between this Sku Qualification and the information NABP has sent to us. Click SAVE to update those fields",
  acpeBulkAddWarning:
    "We currently don't support adding multiple SKU Qualifications and validating them with the Submission Authority. Are you sure you want to proceed without validation?",
  // --- Sku Qualification Wizard ---
  skuQualificationAddTitle: "Add Qualification",
  skuQualificationEditTitle: "Edit Qualification",
  skuQualificationWizardStepSelect: "Select Qualification",
  skuQualificationWizardStepConfigure: "Configure Details",
  skuQualificationWizardStep1Help:
    "Pick any one field, it becomes the anchor, and the other two auto-fill with every option the qualification table links to it. Removing a linked chip drops that link on both sides; the last option holding the set together is locked. Click the anchor chip to clear everything and start over.",
  skuQualificationLinkLocked:
    "Every remaining entry carries this value. Clear the anchor to start over.",
  skuQualificationEntryCount:
    "{count, plural, one {# entry} other {# entries}}",
  skuQualificationEntriesWillBeCreated:
    "{count, plural, one {# entry} other {# entries}} will be created",
  searchFieldPlaceholder: "Search {field}...",
  skuQualificationPartialSaveError:
    "Saved {saved} of {total} qualifications before failing.",
  subjectAreaPlaceholder: "Select a subject area...",
  subjectAreaAccreditor:
    "Subject area labels shown for accreditor: {accreditor}",
  addCredit: "ADD CREDIT",
  removeCreditLine: "remove credit line",
  totalCredits: "Total: {total} credits",
  creditLinesVaryByEntry: "Credit lines vary by entry",
  accreditorPublishesNoSubjectAreas: "{accreditor} publishes no subject areas",
  creditsFromTheSkuDetails: "{credits} credits from the Sku Details",
};

export default en;
